import { useEffect, useState, useRef } from "react";
import { withRouter } from "../../utils/withRouter";
import { Button, Modal, Toast, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import S3 from "react-aws-s3";
import { v4 as uuidv4 } from "uuid";
import CancelIcon from "@material-ui/icons/Cancel";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddPhotoAlternate from "@material-ui/icons/AddPhotoAlternate";
import { SketchPicker } from "react-color";
import Barcode from "react-barcode";
import WarningIcon from "../../assets/icons/warning.svg";
import { FaEdit } from "react-icons/fa";
import {
  DatePicker,
  Switch as AntdSwitch,
  theme,
  Popconfirm,
  Button as AntdButton,
  Tabs,
  Card,
  Dropdown,
  Typography,
  Alert,
  Col,
  Row,
  ColorPicker,
  App,
  Space,
  Tooltip,
} from "antd";
import { defaultLowStockAlert } from "../../config";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import CustomTable from "../../components/table";
import { RiDeleteBin6Line, RiEditLine } from "react-icons/ri";
import UpgradeIcon from "../../assets/icons/upgradeIcon.svg";
import CustomTabs from "../tabs";
import ProductExcelUpload from "./productExcelUpload";
import Taxmaster from "../dashboard/Tax Master/index";
import AddCategories from "./addCategories";
import { EllipsisOutlined } from "@ant-design/icons";
import { GrStatusWarning } from "react-icons/gr";
import dayjs from "dayjs";
import { useAccess } from "../../provider/AccessProvider";
import { PRODUCTACCESS } from "../../utils/constant";
import { useHotkeys } from "react-hotkeys-hook";
import { v4 } from "uuid";
import { AiOutlineInfoCircle } from "react-icons/ai";

const UNIT = [
  "g",
  "kg",
  "mg",
  "ml",
  "L",
  "cup",
  "count",
  "box",
  "pkt",
  "glass",
  "cm",
  "m",
  "km",
  "min",
  "hour",
  "days",
  "inch",
  "ton",
];

var INITIAL_STATE = {
  productBrand: "",
  productName: "",
  group: "",
  category: "",
  subCategory: "",
  productMrp: "",
  productPrice: "",
  measurmentValue: "",
  measurmentUnit: "",
  b2bProductPrice: "",
  inventoryQty: "",
  purchasePrice: "",
  productEANCode: "",
  productHsnCode: "",
  productCode: "",
  productWastage: "",
  productLabour: "",
  lowStockAlert: "5",
  vegNonVeg: "",
  productTax: "",
  productTaxType: "",
  discountPrice: "",
  discountType: "",
  imei1: "",
  imei2: "",
  size: "",
  duration: "",
  productImageArray: [],
  productType: "product",
  frequentPriceChange: false,
  taxIncExc: "",
  taxId: "",
  expiryDate: "",
  productDescription: "",
};

const EditUnit = ({ productData, handleVariantInputChange, rowSelection }) => {
  const [edit, setEdit] = useState(false);
  return (
    <>
      {!edit && (
        <>
          <>
            {productData.color && (
              <label
                style={{
                  // marginBottom: "-10px",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  border: "2px solid grey",
                  backgroundColor: `${productData.color}`,
                }}
              >
                {" "}
              </label>
            )}
            {productData.unitOfMeasurment && (
              <label
                style={{
                  margin: "5px",
                }}
              >
                {productData.unitOfMeasurment}{" "}
              </label>
            )}
            {productData.size && (
              <label
                style={{
                  margin: "5px",
                }}
              >
                {productData.size}{" "}
              </label>
            )}
          </>
          {rowSelection && (
            <AntdButton
              style={{
                position: "absolute",
                right: "0",
              }}
              onClick={() => {
                setEdit(true);
              }}
              type="link"
            >
              <FaEdit size={24} />
            </AntdButton>
          )}
        </>
      )}
      {edit && (
        <Row id="editUnitContainer" gutter={[0, 10]}>
          <Col span={6}>UOM:</Col>
          <Col
            span={18}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              span={16}
            >
              <input
                value={productData.measurmentValue}
                placeholder="Measurement Value"
                name="measurmentValue"
                style={{
                  width: "100%",
                  border: "1px solid #000",
                  borderRight: "none",
                }}
                onChange={(e) =>
                  handleVariantInputChange(
                    e.target.name,
                    e.target.value,
                    productData.productId,
                  )
                }
                type="number"
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col span={8}>
              <select
                id="unit-select"
                style={{
                  height: "26.5px",
                  width: "100%",
                  background: "transparent",
                  outline: "none",
                }}
                name="measurmentUnit"
                value={productData.measurmentUnit}
                onChange={(e) =>
                  handleVariantInputChange(
                    e.target.name,
                    e.target.value,
                    productData.productId,
                  )
                }
              >
                <option value="" selected disabled>
                  unit
                </option>
                {UNIT.map((data) => {
                  return (
                    <option key={data} value={data}>
                      {data}
                    </option>
                  );
                })}
              </select>
            </Col>
          </Col>

          <Col span={6}>Size:</Col>
          <Col style={{ textAlign: "left" }} span={18}>
            <input
              value={productData.size}
              placeholder="Eg: Small"
              style={{ width: "100%", border: "1px solid" }}
              onChange={(e) =>
                handleVariantInputChange(
                  e.target.name,
                  e.target.value,
                  productData.productId,
                )
              }
              name="size"
              onWheel={(e) => e.target.blur()}
            />
          </Col>
          <Col span={6}>Color:</Col>
          <Col style={{ textAlign: "left" }} span={18}>
            <ColorPicker
              value={productData.color || "#fff"}
              onChangeComplete={(v) => {
                handleVariantInputChange(
                  "color",
                  v.toHexString(),
                  productData.productId,
                );
              }}
              format="hex"
              getPopupContainer={(e) =>
                document.getElementById("variant-modal")
              }
            />
          </Col>
        </Row>
      )}
    </>
  );
};

const disabledDate = (current) => {
  // If the date is before today, disable it
  return current && current < dayjs().startOf("day");
};

const Items = (props) => {
  const {
    token: { colorPrimary, colorTextSecondary, colorBgContainer },
  } = theme.useToken();
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const dispatch = useDispatch();
  const [isUpgradingToVariant, setUpgradingToVariant] = useState(false);

  useEffect(() => {
    function keydownHandler(event) {
      // event.preventDefault();
      // event.stopPropagation();
      if (event.altKey && event.keyCode == 85) {
        // Excel upload for product (U)
        props.history.push("/dashboard/excel-upload");
      } else if (event.altKey && event.keyCode == 78) {
        // Add Item/product (N)
        setAddProductModal(true);
      } else if (event.altKey && event.keyCode == 84) {
        // TaxMaster (T)
        props.history.push("/dashboard/shop-items/tax-master");
      }
    }
    document.addEventListener("keydown", keydownHandler);
    return () => {
      window.removeEventListener("keydown", keydownHandler);
    };
  }, []);

  const shopDetails = useSelector((state) => state.shopDetails);
  //const shopDetails.shopType = "Supermarket";
  const { message } = App.useApp();
  const [activeTab, setActiveTab] = useState("1");
  const currencyFormatter = useCurrency();
  const [uomArray, setUomArray] = useState([]);
  const [sizeArray, setSizeArray] = useState([]);
  const [colorArray, setColorArray] = useState([]);
  const [variantUnitValue, setVariantUnitValue] = useState("");
  const [variantUnit, setVariantUnit] = useState("");
  const [variantColor, setVariantColor] = useState("");
  const [variantSize, setVariantSize] = useState("");
  const [variantType, setVariantType] = useState("");
  const [variantModal, setVariantModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [addProductModal, setAddProductModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    data: {},
  });
  const [editVariantUnits, setEditVariantUnits] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [rowSelection, setRowSelection] = useState(false);
  const [rowSelectedProduct, setRowSelectedProduct] = useState([]);
  const access = useAccess(PRODUCTACCESS);
  const [newQty, setNewQty] = useState(0);
  // const [collection, setCollection] = useState([]);
  const [editProductModal, setEditProductModal] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [deleteDisable, setDeleteDisable] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageArrayUrl, setImageArrayUrl] = useState([]);
  const ref = useRef();
  const [productDetails, setProductDetails] = useState({
    ...INITIAL_STATE,
  });
  const [editProducts, setEditProducts] = useState({
    ...INITIAL_STATE,
    productId: "",
    masterId: "",
    productImage: "",
    versionId: "",
    status: "",
    existingInventoryQty: "",
  });
  const [upgradingToProductData, setUpgradingToProductData] = useState({});
  const [hasVariant, setHasVariant] = useState(false); //change
  const [showToast, setShowToast] = useState(false);
  const [loadingId, setLoadingId] = useState("");

  const [colorPickerArray, setColorPickerArray] = useState([
    "#000000",
    "#FFFFFF",
    "#FF0000",
    "#00FF00",
    "#FF00FF",
    "#00FFFF",
    "#FFFF00",
    "#0000FF",
    "#ACD038",
    "#F60B8A",
    "#14838E",
    "#D3D3D3",
    "#808080",
    "#FEF200",
    "#FCCC00",
    "#FE8F01",
    "#F95201",
    "#FE0000",
    "#AB31AA",
    "#7A1FA0",
    "#7542FF",
    "#1060FF",
    "#198E7C",
    "#24B550",
    "#89E23C",
    "#8B570E",
    "#F8C8DC",
    "#F62681",
    "#E89623",
  ]);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const [variants, setVariants] = useState([]);
  const [colorPickerType, setColorPickerType] = useState("preset");
  const [oldVariants, setOldVariants] = useState([]);
  const [categoryList, setCategoryList] = useState({});
  const [group, setGroup] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [excelDownloadLoading, setExcelDownloadLoading] = useState(false);
  const taxList = useSelector((state) => state.taxList.taxList);
  const [isLoading, setIsLoading] = useState(true);
  const country = useCountry();

  const getProductDetails = async (shopId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          type: "getProductDetails",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.limitExceeds && data.status) {
          try {
            var productData = await fetch(data.products);
            productData = await productData.json();
            productData = productData.map((i) => {
              let measurement = {
                measurmentUnit: "",
                measurmentValue: "",
              };
              if (
                data.unitOfMeasurment !== "Others" &&
                i.hasOwnProperty("unitOfMeasurment")
              ) {
                measurement.measurmentUnit = i.unitOfMeasurment.split(" ")[1];
                measurement.measurmentValue = i.unitOfMeasurment.split(" ")[0];
              }
              if (data.unitOfMeasurment === "Others") {
                measurement.measurmentUnit = i.unitOfMeasurment;
                measurement.measurmentValue = i.unitOfMeasurment;
                data.unitOfMeasurment = "";
              }
              return {
                ...i,
                measurmentUnit: measurement.measurmentUnit,
                measurmentValue: measurement.measurmentValue,
              };
            });
            let sortedArr = productData.sort((a, b) => {
              if (a.productName === b.productName) return 0;
              if (a.productName > b.productName) return 1;
              return -1;
            });
            setProducts(sortedArr);
            setIsLoaded(true);
            const addToLocalStroage = sortedArr?.map((i) => {
              let label = i.productName;
              if (
                i.unitOfMeasurment !== "Others" &&
                i.unitOfMeasurment !== "" &&
                !i.unitOfMeasurment !== true
              ) {
                label = `${i.productName} (${i.unitOfMeasurment})`;
              }
              return {
                id: i.productId,
                name: label,
                productEANCode: i.productEANCode,
                productCode: i.productCode,
                color: i.color,
                size: i.size,
                value: i.productName.toLowerCase(),
              };
            });
            dispatch({
              type: "SET_PRODUCT_LIST",
              payload: sortedArr,
            });

            dispatch({
              type: "SET_PRODUCTS_SEARCH",
              payload: addToLocalStroage,
            });
            return;
          } catch (err) {
            alert("Failed to fetch product details. Please try again");
            return;
          }
        }
        const updatedProduct = data.products.map((i) => {
          let measurement = {
            measurmentUnit: "",
            measurmentValue: "",
          };
          if (
            i.unitOfMeasurment !== "Others" &&
            i.hasOwnProperty("unitOfMeasurment")
          ) {
            measurement.measurmentUnit = i.unitOfMeasurment.split(" ")[1];
            measurement.measurmentValue = i.unitOfMeasurment.split(" ")[0];
          }
          if (i.unitOfMeasurment === "Others") {
            measurement.measurmentUnit = "";
            measurement.measurmentValue = "";
            i.unitOfMeasurment = "";
          }
          return {
            ...i,
            measurmentUnit: measurement.measurmentUnit,
            measurmentValue: measurement.measurmentValue,
          };
        });
        var sortedArr = updatedProduct.sort((a, b) => {
          if (a.productName === b.productName) return 0;
          if (a.productName > b.productName) return 1;
          return -1;
        });

        setProducts(sortedArr);
        setIsLoaded(true);

        const addToLocalStroage = sortedArr?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            productEANCode: i.productEANCode,
            productCode: i.productCode,
            color: i.color,
            size: i.size,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: sortedArr,
        });

        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
      })
      .catch((err) => {
        console.log("Err", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    (async function () {
      if (shopDetails.shopId === "") return;
      // if (
      //   shopDetails.empId &&
      // )
      //   return props.history.push("/dashboard/overview");
      if (
        shopDetails.shopType === "Supermarket" ||
        shopDetails.shopType === "Provisional Store"
      ) {
        var json = await fetch(config.productCategory);
        json = await json.json();
        setCategoryList(json);
      } else {
        if (Object.keys(shopDetails.categoryList).length <= 0) {
          var list = {
            OTHERS: {
              subCategory: ["OTHERS"],
              imageUrl: "",
            },
          };
          setCategoryList(list);
        } else {
          const defaultCategory = {
            ...shopDetails.categoryList,
            ...(shopDetails.categoryList["OTHERS"]
              ? { OTHERS: shopDetails.categoryList["OTHERS"] }
              : {
                  OTHERS: {
                    imageUrl: "",
                    subCategory: ["others"],
                  },
                }),
          };
          setCategoryList(defaultCategory);
        }
      }
      await getProductDetails(shopDetails.shopId);
    })();
  }, [shopDetails]);

  useEffect(() => {
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    )
      return;
    var arr = [];
    try {
      arr = categoryList[editProducts.category.toUpperCase()].subCategory;

      setSubCategory([...arr]);
    } catch (err) {
      setSubCategory([]);
    }
  }, [editProducts.category]);

  const categorySelector = (group, from) => {
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    ) {
      var arr = [];
      arr = Object.entries(categoryList.groups[group].category).map(
        ([key, value]) => key,
      );
      setCategory([...arr]);
      if (from === "add") {
        setProductDetails({
          ...productDetails,
          group: group,
          category: "",
          subCategory: "",
        });
      } else if (from === "edit") {
        setEditProducts({
          ...editProducts,
          category: "",
          subCategory: "",
          group: group,
        });
      }
    }
  };

  const subCategorySelector = (category, from) => {
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    ) {
      var group = from === "add" ? productDetails.group : editProducts.group;
      var arr = [];
      arr = categoryList.groups[group].category[category].subCategory;

      setSubCategory([...arr]);
      if (from === "add") {
        setProductDetails({
          ...productDetails,
          category: category,
          subCategory: "",
        });
      } else if (from === "edit") {
        setEditProducts({
          ...editProducts,
          subCategory: "",
          category: category,
        });
      }
    } else {
      if (from === "add") {
        setProductDetails({
          ...productDetails,
          category: category,
        });
        var arr = [];
        categoryList[category].subCategory.map((item) => {
          arr.push(item);
        });
        const subCategories = [...arr].map((i) => i.toLowerCase());
        setSubCategory([...new Set(subCategories)]);
      }
    }
  };

  const inputChangeHandler = (e) => {
    setProductDetails({
      ...productDetails,
      [e.target.name]: e.target.value,
    });
  };

  const taxableValueFunc = (
    productPrice = 0,
    productTax = 0,
    count,
    taxIncExc = "inclusive",
  ) => {
    let result = 0;
    if (true) {
      if (taxIncExc === "inclusive") {
        result =
          (productPrice / (100 + parseInt(productTax || 0))) *
          parseFloat(count || 0) *
          100;
      } else if (taxIncExc === "exclusive") {
        result = productPrice * parseFloat(count || 0);
      } else {
        result = productPrice * count;
      }
    }
    return result;
  };

  const taxTypeFunc = (taxableValue, selectedTax) => {
    const customTaxValue = {};

    selectedTax?.productTaxType?.forEach((tax) => {
      const taxTypeName =
        customTaxType.find((customTax) => customTax.taxId === tax)?.taxName ||
        tax;
      customTaxValue[taxTypeName] =
        (customTaxValue[taxTypeName] || 0) +
        parseFloat(
          taxableValue * (parseFloat(selectedTax[taxTypeName] || 0) / 100),
        );
    });

    const sumOfTax = Object.values(customTaxValue).reduce(
      (acc, cur) => acc + cur,
      0,
    );
    const itemTotal = parseFloat(taxableValue) + sumOfTax;
    return {
      ...customTaxValue,
      productTaxType: Object.keys(customTaxValue),
      itemTotal,
      taxableValue,
      totalBeforeTax: taxableValue,
    };
  };

  const prevTaxTypeFunc = (
    taxableValue,
    productTax = 0,
    productTaxType = "gst",
  ) => {
    let gst = 0;
    let cess = 0;
    let igst = 0;
    let additionalcess = 0;
    let totalPrice = 0;
    if (true) {
      if (productTaxType === "gst") {
        gst = taxableValue * (parseInt(productTax || 0) / 100);
      } else if (productTaxType === "cess") {
        cess = ((taxableValue * parseInt(productTax || 0)) / 100).toFixed(2);
      } else if (productTaxType === "additionalcess") {
        additionalcess = (taxableValue * parseInt(productTax || 0)) / 100;
      } else if (productTaxType === "igst") {
        igst = (taxableValue * parseInt(productTax || 0)) / 100;
      }
    }
    const total =
      parseFloat(gst) +
      parseFloat(cess) +
      parseFloat(additionalcess) +
      parseFloat(taxableValue) +
      parseFloat(igst);
    totalPrice = Math.round(total).toFixed(2);
    return { gst, cess, igst, additionalcess, itemTotal: totalPrice };
  };

  const addProduct = async () => {
    if (productDetails.measurmentValue && !productDetails.measurmentUnit) {
      return alert("Please select the measurment of Unit!");
    }
    if (productDetails.measurmentUnit && !productDetails.measurmentValue) {
      return alert("Please select the measurment of value!");
    }

    if (!productDetails.discountType && productDetails.discountPrice) {
      return alert("Please select the discount type!");
    }
    if (productDetails.discountType && productDetails.discountPrice) {
      if (
        productDetails.discountType === "flat" &&
        parseFloat(productDetails.discount) >
          parseFloat(productDetails.productPrice)
      ) {
        return alert("Discount cannot be greater than Selling Price!");
      }
      if (
        productDetails.discountType === "flat" &&
        shopDetails.advanceSettings?.b2bPricing &&
        parseFloat(productDetails.discountPrice) >
          parseFloat(productDetails.b2bProductPrice)
      ) {
        return alert("Discount cannot be greater than B2B Selling Price!");
      }
    }

    if (productDetails.taxIncExc && !productDetails.taxId) {
      return alert("Please select the tax!");
    }
    if (!productDetails.taxIncExc && productDetails.taxId) {
      return alert("Please select the Inclusive/Exclusive!");
    }
    if (
      productDetails.group === "" &&
      (shopDetails.shopType === "Supermarket" ||
        shopDetails.shopType === "Provisional Store")
    )
      return alert("Please select a group");
    if (productDetails.category === "")
      return alert("Please select a category");
    if (productDetails.subCategory === "")
      return alert("Please select a Subcategory");

    var tempArray = variants.map((data) => {
      return {
        ...data,
        inventoryQty: data.inventoryQty ? parseFloat(data.inventoryQty) : 0,
        b2bProductPrice: undefined, // undefined is used to indicate that this field is not required and not sent to backend
        ...(data.b2bProductPrice && {
          b2bProductPrice: data.b2bProductPrice,
        }),
        frequentPriceChange: productDetails.frequentPriceChange,
        group: productDetails.group,
        category: productDetails.category ? productDetails.category : "OTHERS",
        subCategory: productDetails.subCategory,
        productBrand: productDetails.productBrand,
        productName: productDetails.productName,
      };
    });
    if (productDetails.productName === "") {
      return alert("please enter product name");
    }
    if (!productDetails.inventoryQty && !hasVariant) {
      return alert("Please enter the inventory quantity!");
    }

    if (productDetails.discountType && !productDetails.discountPrice) {
      return alert("Please enter the discount!");
    }
    if (
      !(
        Number(productDetails.discountPrice) <= 100 &&
        Number(productDetails.discountPrice) > 0
      ) &&
      productDetails.discountType === "percentage" &&
      !hasVariant
    ) {
      return alert(
        "Discount must be less than equal to 100 and greater than 0!",
      );
    }
    if (hasVariant) {
      ///
      var indexArr = [];
      var message = "";
      variants.map((data, i) => {
        if (data.productPrice === "" || data.productPrice === undefined) {
          indexArr.push(i + 1);
          message = "Please Enter Selling price for Item Number(s): ";
          return;
        }
      });
      if (indexArr.length === 0) {
        message = "Selling Price is greater than MRP for Item Number(s): ";
        variants.map((data, i) => {
          if (
            data.productMrp !== "" &&
            parseFloat(data.productMrp) < parseFloat(data.productPrice)
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0 && shopDetails.advanceSettings?.b2bPricing) {
        message = "B2B Selling Price is greater than MRP for Item Number(s): ";
        variants.map((data, i) => {
          if (
            data.productMrp !== "" &&
            parseFloat(data.productMrp) < parseFloat(data.b2bProductPrice)
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0 && shopDetails.advanceSettings?.b2bPricing) {
        message =
          "B2B Selling price exceeding the MRP after applying tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.productMrp !== "") {
            var selectedTax = {};
            var taxs = {};
            if (data.taxId) {
              selectedTax = taxList.find(
                (taxObj) => taxObj.taxId.toString() === data.taxId.toString(),
              );
              let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
                (acc, curr) => {
                  const taxTypeName =
                    customTaxType.find((customTax) => customTax.taxId === curr)
                      ?.taxName || curr;
                  return acc + parseFloat(selectedTax[taxTypeName] || 0);
                },
                0,
              );
              var taxableValue = taxableValueFunc(
                data.b2bProductPrice,
                totalTaxPercentage,
                1,
                data.taxIncExc,
              );
              taxs = taxTypeFunc(taxableValue, selectedTax);

              if (parseFloat(data.productMrp) < taxs.itemTotal)
                return indexArr.push(i + 1);
            }
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Selling price exceeding the MRP after applying tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.productMrp !== "") {
            var selectedTax = {};
            var taxs = {};
            if (data.taxId) {
              selectedTax = taxList.find(
                (taxObj) => taxObj.taxId.toString() === data.taxId.toString(),
              );
              let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
                (acc, curr) => {
                  const taxTypeName =
                    customTaxType.find((customTax) => customTax.taxId === curr)
                      ?.taxName || curr;
                  return acc + parseFloat(selectedTax[taxTypeName] || 0);
                },
                0,
              );
              var taxableValue = taxableValueFunc(
                data.productPrice,
                totalTaxPercentage,
                1,
                data.taxIncExc,
              );
              taxs = taxTypeFunc(taxableValue, selectedTax);

              if (parseFloat(data.productMrp) < taxs.itemTotal)
                return indexArr.push(i + 1);
            }
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Enter Stock Count for Item Number(s): ";
        variants.map((data, i) => {
          if (!data.inventoryQty) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Inventory Quantity must be for Item Number(s): ";
        variants.map((data, i) => {
          if (!/^\d+(\.\d+)?$/.test(data.inventoryQty)) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Discount Type for Item Number(s): ";
        variants.map((data, i) => {
          if (data.discountPrice && !data.discountType) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please enter the Discount Amount for Item Number(s): ";
        variants.map((data, i) => {
          if (data.discountType && !data.discountPrice) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Discount must be less than equal to 100 and greater than 0 for Item Number(s): ";
        variants.map((data, i) => {
          if (
            !(
              Number(data.discountPrice) > 0 &&
              Number(data.discountPrice <= 100)
            ) &&
            data.discountType === "percentage"
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Discount Amount is greater than Selling Price for Item Number(s): ";
        variants.forEach((data, i) => {
          if (data.discountType && data.discountPrice) {
            if (
              data.discountType === "flat" &&
              parseFloat(data.discountPrice) > parseFloat(data.productPrice)
            ) {
              indexArr.push(i + 1);
              return;
            }
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Tax Type for Item Number(s): ";
        variants.map((data, i) => {
          if (data.taxId && !data.taxIncExc) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.taxIncExc && !data.taxId) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.taxIncExc && !data.taxId) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length > 0) {
        return alert(message + indexArr.join(", "));
      }
      if (variants.length === 0) {
        return alert("Please add atleast one variant to add.");
      }
    } else {
      if (productDetails.productPrice === "")
        return alert("Please enter selling price");
      if (productDetails.productMrp !== "") {
        if (
          parseFloat(productDetails.productPrice) >
          parseFloat(productDetails.productMrp)
        ) {
          return alert("Selling price should not be greater than MRP");
        }

        if (
          shopDetails.advanceSettings?.b2bPricing &&
          parseFloat(productDetails.b2bProductPrice) >
            parseFloat(productDetails.productMrp)
        ) {
          return alert("B2B Selling price should not be greater than MRP");
        }

        var selectedTax = {};
        var taxs = {};
        if (productDetails.taxId) {
          selectedTax = taxList.find(
            (data) => data.taxId.toString() === productDetails.taxId.toString(),
          );
          let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
            (acc, curr) => {
              const taxTypeName =
                customTaxType.find((customTax) => customTax.taxId === curr)
                  ?.taxName || curr;
              return acc + parseFloat(selectedTax[taxTypeName] || 0);
            },
            0,
          );
          var taxableValue = taxableValueFunc(
            productDetails.productPrice,
            totalTaxPercentage,
            1,
            productDetails.taxIncExc,
          );
          taxs = taxTypeFunc(taxableValue, selectedTax);
          if (
            parseFloat(productDetails.productMrp) < Math.round(taxs.itemTotal)
          )
            return alert("Selling price exceeding the MRP after applying tax.");
          if (
            shopDetails.advanceSettings?.b2bPricing &&
            productDetails.b2bProductPrice
          ) {
            const taxableValue = taxableValueFunc(
              productDetails.b2bProductPrice,
              totalTaxPercentage,
              1,
              productDetails.taxIncExc,
            );
            taxs = taxTypeFunc(taxableValue, selectedTax);

            if (parseFloat(productDetails.productMrp) < taxs.itemTotal)
              return alert(
                "B2B Selling price exceeding the MRP after applying tax.",
              );
          }
        }
      }
    }
    setDisabled(true);
    var body = {};
    if (hasVariant) {
      body = {
        hasVariant: true,
        products: tempArray,
        type: "addProducts",
        shopId: shopDetails.shopId,
      };
    } else {
      body = {
        hasVariant: false,
        product: {
          ...productDetails,
          expiryDate: productDetails.expiryDate
            ? dayjs(productDetails.expiryDate).format("YYYY-MM-DD")
            : "",
          productImageArray: imageArrayUrl,
          shopId: shopDetails.shopId,

          b2bProductPrice: undefined, // undefined is used to indicate that this field is not required and not sent to backend
          ...(productDetails.b2bProductPrice && {
            b2bProductPrice: productDetails.b2bProductPrice,
          }),
          ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
            shopId: shopDetails.shopId,
            parentShopId: shopDetails.ownerShopId,
          }),
        },
        type: "addProducts",
        shopId: shopDetails.shopId,
      };
    }
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setProductDetails({
          ...INITIAL_STATE,
        });
        getProductDetails(shopDetails.shopId);
        setImageArrayUrl([]);
        setSubCategory([]);
        setDisabled(false);
        variantResetData();
        setVariants([]);
        alert("Product added successfully");
      })
      .catch((err) => {
        console.log("Err", err);
        setDisabled(false);
      });
  };

  const handleUpgradeEdit = (data, selectedRows) => {
    console.log("selectedRows", selectedRows);
    setHasVariant(true);
    const tempVariants = selectedRows.map((i) => {
      return {
        ...i,
        key: i.unitOfMeasurment,
        productName: "",
      };
    });
    const units = [];
    tempVariants.forEach((i) => {
      if (i.unitOfMeasurment) {
        units.push(i.unitOfMeasurment);
      }
    });

    setVariants([...tempVariants]);

    setOldVariants([...tempVariants]);
    setUomArray(units);

    var tempGroup = data.group ? data.group : "";
    var tempCategory = data.category;
    var tempSubCategory = data.subCategory ? data.subCategory : "";
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    ) {
      var catArr = [];
      var subCatArr = [];
      if (Object.keys(categoryList.groups).includes(data.group)) {
        catArr = Object.entries(categoryList.groups[data.group].category).map(
          ([key, value]) => key,
        );

        if (catArr.includes(data.category)) {
          subCatArr =
            categoryList.groups[data.group].category[data.category].subCategory;
        } else {
          tempCategory = "";
          tempSubCategory = "";
        }
      } else {
        tempCategory = "";
        tempGroup = "";
        tempSubCategory = "";
      }
      setSubCategory([...subCatArr]);
      setCategory([...catArr]);
    }

    console.log("tempCategory,", tempCategory, tempSubCategory);
    setEditProducts({
      ...INITIAL_STATE,
      b2bProductPrice: data.b2bProductPrice,
      productId: data.productId,
      productDescription: data.productDescription,
      versionId: data.versionId,
      productName: isUpgradingToVariant || rowSelection ? "" : data.productName,
      productBrand:
        isUpgradingToVariant || rowSelection
          ? ""
          : data.productBrand !== "Others"
            ? data.productBrand
            : "",
      group: tempGroup,
      category: tempCategory,
      subCategory: tempSubCategory,
      inventoryQty: data.inventoryQty ? parseFloat(data.inventoryQty) : "",
      purchasePrice: data.purchasePrice,
      productMrp: data.productMrp !== "TBD" ? data.productMrp : "",
      productPrice: data.productPrice !== "TBD" ? data.productPrice : "",
      productLabour: data.productLabour ? data.productLabour : "",
      productWastage: data.productWastage ? data.productWastage : "",
      measurmentValue: data.unitOfMeasurment
        ? data.unitOfMeasurment !== "Others"
          ? data.unitOfMeasurment.split(" ")[0]
          : ""
        : "",
      measurmentUnit: data.unitOfMeasurment
        ? data.unitOfMeasurment !== "Others"
          ? data.unitOfMeasurment.split(" ")[1]
          : ""
        : "",
      productEANCode: data.productEANCode !== "TBD" ? data.productEANCode : "",
      productImageArray: data.productImageArray
        ? data.productImageArray
        : data.productImage
          ? data.productImage !== "removed"
            ? [data.productImage]
            : []
          : [],
      vegNonVeg: data.vegNonVeg ? data.vegNonVeg : "",
      status: data.status,
      productCode: data.productCode ? data.productCode : "",
      discountPrice: data.discountPrice ? data.discountPrice : "",
      productTax: data.productTax ? data.productTax : "",
      productTaxType: data.productTaxType ? data.productTaxType : "",
      discountType: data.discountType ? data.discountType : "",
      productHsnCode: data.productHsnCode ? data.productHsnCode : "",
      existingInventoryQty: data.inventoryQty
        ? parseFloat(data.inventoryQty)
        : parseFloat(data.inventoryQty),
      size: data.size ? data.size : "",
      productImage: data.productImage ? data.productImage : "",
      productType: data.productType ? data.productType : "product",
      frequentPriceChange: data.frequentPriceChange
        ? data.frequentPriceChange
        : false,
      taxIncExc: data.taxIncExc === "Inclusive/Exclusive" ? "" : data.taxIncExc,
      taxId: data.taxId === "Select Tax" ? "" : data.taxId,
      lowStockAlert: parseFloat(data.lowStockAlert) || 5,
      expiryDate: data.expiryDate,
    });
    if (data.productImageArray) {
      setImageArrayUrl(data.productImageArray);
    } else if (data.productImage && data.productImage !== "removed") {
      setImageArrayUrl([data.productImage]);
    }
    setEditProductModal(true);
  };

  console.log("variants111", variants);

  const editProduct = (data) => {
    if (data.parentProductId && data.parentProductId !== "NA") {
      setHasVariant(true);
      var tempVariants = products.filter(
        (key) => key.parentProductId === data.parentProductId,
      );
      console.log("tempVariants", tempVariants);
      setVariants([...tempVariants]);
      var keyArr = tempVariants[0]?.type?.split("-");
      var tempColor = [],
        tempSize = [],
        tempUom = [];
      tempVariants.map((data) => {
        if (keyArr?.includes("color") && !tempColor.includes(data.color)) {
          tempColor.push(data.color);
        }
        if (keyArr?.includes("size") && !tempSize.includes(data.size)) {
          tempSize.push(data.size);
        }
        if (
          keyArr?.includes("UOM") &&
          !tempUom.includes(data.unitOfMeasurment)
        ) {
          tempUom.push(data.unitOfMeasurment);
        }
      });
      setOldVariants([...tempVariants]);
      setColorArray([...tempColor]);
      setSizeArray([...tempSize]);
      setUomArray([...tempUom]);
    }
    var tempGroup = data.group ? data.group : "";
    var tempCategory = data.category;
    var tempSubCategory = data.subCategory ? data.subCategory : "";
    if (
      shopDetails.shopType === "Supermarket" ||
      shopDetails.shopType === "Provisional Store"
    ) {
      var catArr = [];
      var subCatArr = [];
      if (Object.keys(categoryList.groups).includes(data.group)) {
        catArr = Object.entries(categoryList.groups[data.group].category).map(
          ([key, value]) => key,
        );

        if (catArr.includes(data.category)) {
          subCatArr =
            categoryList.groups[data.group].category[data.category].subCategory;
        } else {
          tempCategory = "";
          tempSubCategory = "";
        }
      } else {
        tempCategory = "";
        tempGroup = "";
        tempSubCategory = "";
      }
      setSubCategory([...subCatArr]);
      setCategory([...catArr]);
    }
    setEditProducts({
      ...INITIAL_STATE,
      duration: data.duration,
      b2bProductPrice: data.b2bProductPrice,
      productId: data.productId,
      productDescription: data.productDescription,
      versionId: data.versionId,
      productName: data.productName,
      productBrand: data.productBrand !== "Others" ? data.productBrand : "",
      group: tempGroup,
      category: tempCategory,
      subCategory: tempSubCategory,
      inventoryQty: data.inventoryQty ? parseFloat(data.inventoryQty) : "",
      purchasePrice: data.purchasePrice,
      productMrp: data.productMrp !== "TBD" ? data.productMrp : "",
      productPrice: data.productPrice !== "TBD" ? data.productPrice : "",
      productLabour: data.productLabour ? data.productLabour : "",
      productWastage: data.productWastage ? data.productWastage : "",
      measurmentValue: data.unitOfMeasurment
        ? data.unitOfMeasurment !== "Others"
          ? data.unitOfMeasurment.split(" ")[0]
          : ""
        : "",
      measurmentUnit: data.unitOfMeasurment
        ? data.unitOfMeasurment !== "Others"
          ? data.unitOfMeasurment.split(" ")[1]
          : ""
        : "",
      productEANCode: data.productEANCode !== "TBD" ? data.productEANCode : "",
      productImageArray: data.productImageArray
        ? data.productImageArray
        : data.productImage
          ? data.productImage !== "removed"
            ? [data.productImage]
            : []
          : [],
      vegNonVeg: data.vegNonVeg ? data.vegNonVeg : "",
      status: data.status,
      productCode: data.productCode ? data.productCode : "",
      discountPrice: data.discountPrice ? data.discountPrice : "",
      productTax: data.productTax ? data.productTax : "",
      productTaxType: data.productTaxType ? data.productTaxType : "",
      discountType: data.discountType ? data.discountType : "",
      productHsnCode: data.productHsnCode ? data.productHsnCode : "",
      existingInventoryQty: data.inventoryQty
        ? parseFloat(data.inventoryQty)
        : parseFloat(data.inventoryQty),
      size: data.size ? data.size : "",
      productImage: data.productImage ? data.productImage : "",
      productType: data.productType ? data.productType : "product",
      frequentPriceChange: data.frequentPriceChange
        ? data.frequentPriceChange
        : false,
      taxIncExc: data.taxIncExc === "Inclusive/Exclusive" ? "" : data.taxIncExc,
      taxId: data.taxId === "Select Tax" ? "" : data.taxId,
      lowStockAlert: parseFloat(data.lowStockAlert) || 5,
      expiryDate: data.expiryDate,
    });
    if (data.productImageArray) {
      setImageArrayUrl(data.productImageArray);
    } else if (data.productImage && data.productImage !== "removed") {
      setImageArrayUrl([data.productImage]);
    }
    setEditProductModal(true);
  };

  const updateProduct = async () => {
    if (editProducts.measurmentValue && !editProducts.measurmentUnit) {
      return alert("Please select the measurment of Unit!");
    }
    if (editProducts.measurmentUnit && !editProducts.measurmentValue) {
      return alert("Please select the measurment of value!");
    }
    if (editProducts.discountType && !editProducts.discountPrice) {
      return alert("Please enter the discountPrice!");
    }
    if (
      !(
        Number(editProducts.discountPrice) <= 100 &&
        Number(editProducts.discountPrice) > 0
      ) &&
      editProducts.discountType === "percentage" &&
      !hasVariant
    ) {
      return alert(
        "Discount must be less than equal to 100 and greater than 0!",
      );
    }
    if (!editProducts.discountType && editProducts.discountPrice) {
      return alert("Please select the discount type!");
    }
    if (editProducts.discountType && editProducts.discountPrice) {
      if (
        editProducts.discountType === "flat" &&
        parseFloat(editProducts.discountPrice) >
          parseFloat(editProducts.productPrice)
      ) {
        return alert("Discount cannot be greater than Selling Price!");
      }
      if (
        editProducts.discountType === "flat" &&
        shopDetails.advanceSettings?.b2bPricing &&
        parseFloat(editProducts.discountPrice) >
          parseFloat(editProducts.b2bProductPrice)
      ) {
        return alert("Discount cannot be greater than B2B Selling Price!");
      }
    }
    if (editProducts.taxIncExc && !editProducts.taxId) {
      return alert("Please select the tax!");
    }
    if (!editProducts.taxIncExc && editProducts.taxId) {
      return alert("Please select the Inclusive/Exclusive!");
    }
    if (
      (shopDetails.shopType === "Supermarket" ||
        shopDetails.shopType === "Provisional Store") &&
      editProducts.group === ""
    )
      return alert("Please select a group");
    if (editProducts.category === "") return alert("Please select a category");
    if (editProducts.subCategory === "")
      return alert("Please select a Subcategory");
    if (editProducts.productName === "") {
      return alert("please enter product name");
    }
    if (hasVariant) {
      var indexArr = [];
      var message = "";
      variants.map((data, i) => {
        if (data.productPrice === "" || data.productPrice === undefined) {
          indexArr.push(i + 1);
          message = "Please Enter Selling price for Item Number(s): ";
          return;
        }
      });
      if (indexArr.length === 0) {
        message = "Selling Price is greater than MRP for Item Number(s): ";
        variants.map((data, i) => {
          if (
            data.productMrp !== "" &&
            parseFloat(data.productMrp) < parseFloat(data.productPrice)
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0 && shopDetails.advanceSettings?.b2bPricing) {
        message = "B2B Selling Price is greater than MRP for Item Number(s): ";
        variants.map((data, i) => {
          if (
            data.productMrp !== "" &&
            parseFloat(data.productMrp) < parseFloat(data.b2bProductPrice)
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0 && shopDetails.advanceSettings?.b2bPricing) {
        message =
          "B2B Selling price exceeding the MRP after applying tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.productMrp !== "") {
            var selectedTax = {};
            var taxs = {};
            if (data.taxId && data.taxId !== "Select Tax") {
              selectedTax = taxList.find(
                (taxObj) => taxObj.taxId.toString() === data.taxId.toString(),
              );
              let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
                (acc, curr) => {
                  const taxTypeName =
                    customTaxType.find((customTax) => customTax.taxId === curr)
                      ?.taxName || curr;
                  return acc + parseFloat(selectedTax[taxTypeName] || 0);
                },
                0,
              );
              var taxableValue = taxableValueFunc(
                data.b2bProductPrice,
                totalTaxPercentage,
                1,
                data.taxIncExc,
              );
              taxs = taxTypeFunc(taxableValue, selectedTax);
              if (parseFloat(data.productMrp) < taxs.itemTotal)
                indexArr.push(i + 1);
            }
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Selling price exceeding the MRP after applying tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.productMrp !== "") {
            var selectedTax = {};
            var taxs = {};
            if (data.taxId && data.taxId !== "Select Tax") {
              selectedTax = taxList.find(
                (taxObj) => taxObj.taxId.toString() === data.taxId.toString(),
              );
              let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
                (acc, curr) => {
                  const taxTypeName =
                    customTaxType.find((customTax) => customTax.taxId === curr)
                      ?.taxName || curr;
                  return acc + parseFloat(selectedTax[taxTypeName] || 0);
                },
                0,
              );
              var taxableValue = taxableValueFunc(
                data.productPrice,
                totalTaxPercentage,
                1,
                data.taxIncExc,
              );
              taxs = taxTypeFunc(taxableValue, selectedTax);
              if (parseFloat(data.productMrp) < taxs.itemTotal)
                indexArr.push(i + 1);
            }
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Enter Stock Count for Item Number(s): ";
        variants.map((data, i) => {
          if (!data.inventoryQty) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Inventory Quantity must be for Item Number(s): ";
        variants.map((data, i) => {
          if (!/^\d+(\.\d+)?$/.test(data.inventoryQty)) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Discount Type for Item Number(s): ";
        variants.map((data, i) => {
          if (data.discountPrice && !data.discountType) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please enter the Discount Amount for Item Number(s): ";
        variants.map((data, i) => {
          if (data.discountType && !data.discountPrice) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Discount must be less than equal to 100 and greater than 0 for Item Number(s): ";
        variants.map((data, i) => {
          if (
            !(
              Number(data.discountPrice) > 0 &&
              Number(data.discountPrice <= 100)
            ) &&
            data.discountType === "percentage"
          ) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message =
          "Discount Amount is greater than Selling Price for Item Number(s): ";
        variants.forEach((data, i) => {
          if (data.discountType && data.discountPrice) {
            if (
              data.discountType === "flat" &&
              parseFloat(data.discountPrice) > parseFloat(data.productPrice)
            ) {
              indexArr.push(i + 1);
              return;
            }
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Tax for Item Number(s): ";
        variants.map((data, i) => {
          if (data.taxIncExc && !data.taxId) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length === 0) {
        message = "Please Choose the Tax Type for Item Number(s): ";
        variants.map((data, i) => {
          if (data.taxId && !data.taxIncExc) {
            indexArr.push(i + 1);
            return;
          }
        });
      }
      if (indexArr.length > 0) {
        return alert(message + indexArr.join(", "));
      }
      if (variants.length === 0) {
        return alert("Please add atleast one variant to update.");
      }
    } else {
      if (editProducts.productPrice === "")
        return alert("Please enter selling price");
      if (editProducts.productMrp !== "") {
        if (
          parseFloat(editProducts.productPrice) >
          parseFloat(editProducts.productMrp)
        ) {
          return alert("Selling price should not be greater than MRP");
        }
        if (
          shopDetails.advanceSettings?.b2bPricing &&
          parseFloat(editProducts.b2bProductPrice) >
            parseFloat(editProducts.productMrp)
        ) {
          return alert("B2B Selling price should not be greater than MRP");
        }
        var selectedTax = {};
        var taxs = {};
        if (editProducts.taxId) {
          selectedTax = taxList.find(
            (data) => data.taxId.toString() === editProducts.taxId.toString(),
          );
          let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
            (acc, curr) => {
              const taxTypeName =
                customTaxType.find((customTax) => customTax.taxId === curr)
                  ?.taxName || curr;
              return acc + parseFloat(selectedTax[taxTypeName] || 0);
            },
            0,
          );
          var taxableValue = taxableValueFunc(
            editProducts.productPrice,
            totalTaxPercentage,
            1,
            editProducts.taxIncExc,
          );
          taxs = taxTypeFunc(taxableValue, selectedTax);
          if (parseFloat(editProducts.productMrp) < Math.round(taxs.itemTotal))
            return alert("Selling price exceeding the MRP after applying tax.");
          if (
            shopDetails.advanceSettings?.b2bPricing &&
            editProducts.b2bProductPrice
          ) {
            const taxableValue = taxableValueFunc(
              editProducts.b2bProductPrice,
              totalTaxPercentage,
              1,
              editProducts.taxIncExc,
            );
            taxs = taxTypeFunc(taxableValue, selectedTax);

            if (parseFloat(editProducts.productMrp) < taxs.itemTotal)
              return alert(
                "B2B Selling price exceeding the MRP after applying tax.",
              );
          }
        }
      }
      if (editProducts.productPrice === "")
        return alert("Please enter selling price");
    }
    setDisabled(true);

    // try {
    //   const responce = await addUpdatedProduct(variants);
    //   console.log("responce", responce);
    // } catch (err) {
    //   alert("something went wrong please try again");
    //   setDisabled(false);
    // }
    var body = {};
    if (hasVariant) {
      body = {
        hasVariant: hasVariant,
        oldVariants: oldVariants,
        type: "updateOldProduct",
      };

      await Promise.all([
        fetch(
          `${config.newApiGateway}/products/dashboard-products-allproducts`,
          {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          },
        ),
      ])
        .then(([res]) => Promise.all([res.json()]))
        .then(async ([data]) => {
          addUpdatedProduct(variants);
        })
        .catch((err) => {
          alert("something went wrong please try again");
          setDisabled(false);
        });
    } else {
      try {
        const responce = await addUpdatedProduct(variants);
        console.log("responce", responce);
      } catch (err) {
        alert("something went wrong please try again");
        setDisabled(false);
      }
    }

    // else {
    //   body = {
    //     oldVariants: [
    //       {
    //         ...editProducts,
    //       },
    //     ],
    //     type: "updateOldProduct",
    //     hasVariant: false,
    //   };
    // }
  };

  const addUpdatedProduct = async (variants) => {
    var tempArray = variants.map((data) => {
      return {
        ...data,
        b2bProductPrice: undefined, // undefined is used to indicate that this field is not required and not sent to backend
        ...(data.b2bProductPrice && {
          b2bProductPrice: data.b2bProductPrice,
        }),
        frequentPriceChange: editProducts.frequentPriceChange,
        group: editProducts.group,
        category: editProducts.category ? editProducts.category : "OTHERS",
        subCategory: editProducts.subCategory,
        productBrand: editProducts.productBrand,
        productName: editProducts.productName,
      };
    });
    var body = {};
    if (hasVariant) {
      body = {
        type: "createNewVersion",
        hasVariant: hasVariant,
        products: tempArray,
        shopId: shopDetails.shopId,
      };
    } else {
      let inventory =
        parseFloat(newQty || 0) +
        parseFloat(editProducts.existingInventoryQty || 0);
      body = {
        type: "editProduct",
        hasVariant: false,
        shopId: shopDetails.shopId,
        product: {
          ...editProducts,
          inventoryQty: inventory,
          productImageArray: imageArrayUrl,
          shopId: shopDetails.shopId,
          b2bProductPrice: undefined, // undefined is used to indicate that this field is not required and not sent to backend
          ...(editProducts.b2bProductPrice && {
            b2bProductPrice: editProducts.b2bProductPrice,
          }),
          expiryDate: editProducts.expiryDate
            ? dayjs(editProducts.expiryDate).format("YYYY-MM-DD")
            : "",
          ...(["Outlet", "Employee"].includes(shopDetails.userType) && {
            shopId: shopDetails.shopId,
            parentShopId: shopDetails.ownerShopId,
          }),
        },
      };
    }
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (rowSelection) {
          setRowSelectedProduct([]);
          setRowSelection(false);
          message.success("Updated successfully");
        } else {
          alert("Product Updated Successfully");
        }
        setEditProductModal(false);
        setEditProducts({
          ...INITIAL_STATE,
          productId: "",
          masterId: "",
          productImage: "",
          versionId: "",
          existingInventoryQty: "",
          status: "",
        });
        setNewQty(0);
        getProductDetails(shopDetails.shopId);
        setDisabled(false);

        setImageArrayUrl([]);
        variantResetData();
      })
      .catch((err) => {
        console.log("Err", err);
        alert("something went wrong please try again");
        setDisabled(false);
      });
  };

  const deleteProduct = async (data) => {
    setDeleteDisable(true);
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          productId: data.productId,
          versionId: data.versionId,
          type: "deleteProduct",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        getProductDetails(shopDetails.shopId);
        setShowToast(true);
        setDeleteDisable(false);
      })
      .catch((err) => {
        console.log("Err", err);
        alert("Error while deleting, please try again");
        setDeleteDisable(false);
      });
  };
  const makeProductlive = async (data, checked) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/products/dashboard-products-allproducts`, {
        method: "POST",
        body: JSON.stringify({
          type: "makeProductLive",
          productId: data.productId,
          versionId: data.versionId,
          changeStatus: checked ? "live" : "ported",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        getProductDetails(shopDetails.shopId);
        alert("Successfully updated");
      })
      .catch((err) => {
        console.log("Err", err);
        alert("Error while updating status, please try again");
      });
  };

  const [uploading, setUploading] = useState(false);

  const removeImage = (key) => {
    var filteredArr = imageArrayUrl.filter((data) => data !== key);
    setImageArrayUrl(filteredArr);
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const uploadImageToS3 = async ({ originalFiles, folderName, bucketName }) => {
    const files = await Promise.all(
      Array.from(originalFiles).map(async (file) => {
        const base64 = await getBase64(file);
        return {
          base64,
          type: file.type,
        };
      }),
    );
    try {
      const res = await fetch(`${config.uploadTOS3}/uploadToS3`, {
        method: "POST",
        body: JSON.stringify({
          files,
          bucketName,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = async (e) => {
    const acceptType = ["image/png", "image/jpg", "image/jpeg", "image/gif"];

    if (acceptType.includes(e.target.files[0].type)) {
      if (e.target.files.length > 0) {
        var totalCount = imageArrayUrl.length + e.target.files.length;
        if (totalCount > 8) {
          alert("Cannot upload more than 8 images.");
          ref.current.value = "";
          return;
        }
        setUploading(true);
        const res = await uploadImageToS3({
          originalFiles: e.target.files,
          bucketName: "ghoshak-image",
        });
        setImageArrayUrl((prev) => [...prev, ...res]);
        ref.current.value = "";
        setUploading(false);
      }
    } else {
      alert(`You can able to upload file format of ${e.target.files[0].type} `);
    }
  };

  const variantImageUpload = async (e, productData) => {
    const acceptType = ["image/png", "image/jpg", "image/jpeg", "image/gif"];

    if (acceptType.includes(e.target.files[0].type)) {
      var totalCount =
        productData?.productImageArray?.length + e.target.files.length;
      if (e.target.files.length > 0) {
        if (
          e.target.files.length > 2 ||
          productData?.productImageArray?.length > 2 ||
          totalCount > 2
        ) {
          alert("Cannot upload more than 2 images per variant.");
          ref.current.value = "";
          return;
        }
        setLoadingId(productData.productId);
        setUploading(true);
        var tempUri = await uploadImageToS3({
          originalFiles: e.target.files,
          bucketName: "ghoshak-image",
        });
        var tempArr = variants;
        tempArr.find((k) => k.productId === productData.productId)[
          "productImageArray"
        ] = [
          ...tempArr.find((k) => k.productId === productData.productId)?.[
            "productImageArray"
          ],
          ...tempUri,
        ];
        setVariants([...tempArr]);
        // ref.current.value = "";
        setUploading(false);
        setLoadingId("");
      }
    } else {
      message.error(
        `You can able to upload file format of ${e.target.files[0].type} `,
      );
    }
  };

  const removeVariantImage = (key, productData) => {
    var tempArr = variants;
    tempArr.find((data) => data.productId === productData.productId)[
      "productImageArray"
    ] = productData.productImageArray?.filter((data) => data !== key);
    setVariants([...tempArr]);
  };

  const handleVariantInputChange = (key, value, id) => {
    var tempArr = variants;
    tempArr.find((data) => data.productId === id)[key] = value;
    setVariants([...tempArr]);
  };

  const handleRemoveVariant = (key) => {
    var tempArr = variants.filter((data) => data.productId !== key);
    var tempColor = [];
    var tempSize = [];
    var tempUom = [];
    tempArr.map((data) => {
      if (data.color && !tempColor.includes(data.color)) {
        tempColor.push(data.color);
      }
      if (data.size && !tempSize.includes(data.size)) {
        tempSize.push(data.size);
      }
      if (data.unitOfMeasurment && !tempUom.includes(data.unitOfMeasurment)) {
        tempUom.push(data.unitOfMeasurment);
      }
    });
    if (tempColor.length !== colorArray.length) {
      setColorArray([...tempColor]);
    }
    if (tempSize.length !== sizeArray.length) {
      setSizeArray([...tempSize]);
    }
    if (tempUom.length !== uomArray.length) {
      setUomArray([...tempUom]);
    }
    setVariants([...tempArr]);
  };

  const addVariant = () => {
    if (variantType === "UOM") {
      if (variantUnitValue === "") return alert("Enter Unit Value.");
      if (variantUnit === "") return alert("Please Choose Measurement Unit.");
      var uom = variantUnitValue + " " + variantUnit;
      if (uomArray.includes(uom)) {
        VariantInitialState();
        return;
      }
      var tempArr = [...uomArray, uom];
      setUomArray(tempArr);
      VariantInitialState();
    } else if (variantType === "SIZE") {
      if (variantSize === "")
        return alert("Please Enter Size. Eg: Small, Medium.");
      if (sizeArray.includes(variantSize)) {
        VariantInitialState();
        return;
      }
      var tempArr = [...sizeArray, variantSize];
      setSizeArray(tempArr);
      VariantInitialState();
    } else if (variantType === "COLOR") {
      if (variantColor === "") return alert("Please Choose a color.");
      if (colorArray.includes(variantColor)) {
        VariantInitialState();
        return;
      }
      var tempArr = [...colorArray, variantColor];
      setColorArray(tempArr);
      VariantInitialState();
    }
  };

  const variantResetData = () => {
    setHasVariant(false);
    setVariantUnitValue("");
    setVariantUnit("");
    setVariantSize("");
    setVariantColor("");
    setVariants([]);
    setColorArray([]);
    setUomArray([]);
    setSizeArray([]);
    setOldVariants([]);
    setUpgradingToVariant(false);
  };

  const VariantInitialState = () => {
    setVariantModal(!variantModal);
    if (variantType === "UOM") {
      setVariantUnitValue("");
      setVariantUnit("");
    } else if (variantType === "SIZE") {
      setVariantSize("");
    } else if (variantType === "COLOR") {
      setVariantColor("");
    }
    setVariantType("");
  };

  const deleteVariantData = (data, from) => {
    if (from === "UOM") {
      var filteredArr = uomArray.filter((key) => key !== data);
      setUomArray(filteredArr);
    } else if (from === "SIZE") {
      var filteredArr = sizeArray.filter((key) => key !== data);
      setSizeArray(filteredArr);
    } else if (from === "COLOR") {
      var filteredArr = colorArray.filter((key) => key !== data);
      setColorArray(filteredArr);
    }
  };

  const handleColorPick = (e) => {
    setVariantColor(e);
  };

  useEffect(() => {
    processVariantFunction();
  }, [uomArray, sizeArray, colorArray]);

  const processVariantFunction = () => {
    var variantAvilable = [];
    if (colorArray.length > 0) {
      variantAvilable.push("color");
    }
    if (uomArray.length > 0) {
      variantAvilable.push("UOM");
    }
    if (sizeArray.length > 0) {
      variantAvilable.push("size");
    }
    if (variantAvilable.length === 0) return;
    var key = "";
    if (variantAvilable.length === 1) {
      key = variantAvilable[0];
    } else {
      key = variantAvilable.join("-");
    }
    createVariant([colorArray, uomArray, sizeArray], key);
  };

  const createVariant = (args, key) => {
    var newArr = [];
    args.map((data) => {
      if (data.length > 0) {
        newArr.push(data);
      }
    });
    console.log("newArr", newArr);

    var combinations = [],
      max = newArr.length - 1;
    const variantHelperFunction = (arr, i) => {
      for (var j = 0; j < newArr[i].length; j++) {
        var a = arr.slice(0);
        a.push(newArr[i][j]);

        if (i === max) {
          console.log("a1111", a, i, max, combinations);
          combinations.push(a);
        } else variantHelperFunction(a, i + 1);
      }
    };
    variantHelperFunction([], 0);
    console.log("args11", combinations);
    const id = uuidv4();
    var parentId = id;
    var keyArray = key.split("-");
    var todayDate = new Date().toISOString().substring(0, 10);
    var variantsArr = [];
    console.log("combinations", combinations);
    combinations.map((data) => {
      var variantKey = data.join("-");
      var i = variants.findIndex((data) => data.key === variantKey);
      console.log("i8888", i, variants);
      if (i !== -1) {
        var productObj = variants[i];
        productObj = {
          ...productObj,
          parentProductId: parentId,
        };
        variantsArr.push(productObj);
        return;
      }
      var c = "",
        u = "",
        s = "";
      if (keyArray.length === 1) {
        if (keyArray.includes("color")) c = data[0];
        if (keyArray.includes("UOM")) u = data[0];
        if (keyArray.includes("size")) s = data[0];
      } else if (keyArray.length === 2) {
        if (keyArray.includes("color") && keyArray.includes("UOM")) {
          c = data[0];
          u = data[1];
        }
        if (keyArray.includes("color") && keyArray.includes("size")) {
          c = data[0];
          s = data[1];
        }
        if (keyArray.includes("UOM") && keyArray.includes("size")) {
          u = data[0];
          s = data[1];
        }
      } else {
        c = data[0];
        u = data[1];
        s = data[2];
      }
      const id = uuidv4();
      variantsArr.push({
        productId: id,
        versionId: "1",
        inventoryQty: "",
        status: "live",
        group: "",
        category: "",
        subCategory: "",
        productImageArray: [],
        vegNonVeg: "",
        productCode: "",
        productMrp: "",
        duration: "",
        color: c,
        size: s,
        productType: "product",
        shopId: shopDetails.shopId,
        productQty: "1",
        parentProductId: parentId,
        lowStockAlert: "5",
        ownerShopId: "NA",
        latest: "true",
        unitOfMeasurment: u,
        measurmentValue: u.split(" ")[0],
        measurmentUnit: u.split(" ")[1],
        addedDate: todayDate,
        productBrand: "",
        key: data.length === 1 ? data[0] : data.join("-"),
        productEANCode: "",
        productPrice: "",
        productName: "",
        type: key,
        discountPrice: "",
        discountType: "",
        productTaxType: "",
        productTax: "",
        productWastage: "",
        productLabour: "",
        productHsnCode: "",
        purchasePrice: "",
        taxId: "",
        taxIncExc: "",
      });
    });

    let otherVariant = [];
    if (rowSelection || isUpgradingToVariant) {
      otherVariant = oldVariants;
    }
    if (isUpgradingToVariant) {
      const mergingData = variantsArr.map((data, index) => {
        const otherVariantData = otherVariant?.find(
          (i, idex) => idex === index,
        );
        console.log("otherVariantData", otherVariantData, otherVariant);
        if (otherVariantData) {
          return {
            ...data,
            category: otherVariantData.category,
            subCategory: otherVariantData.subCategory,
            productName: otherVariantData.productName,
            productBrand: otherVariantData.productBrand,
            productMrp: otherVariantData.productMrp,
            taxId: otherVariantData.taxId,
            taxIncExc: otherVariantData.taxIncExc,
            productPrice: otherVariantData.productPrice,
            productEANCode: otherVariantData.productEANCode,
            measurmentValue: otherVariantData.measurmentValue,
            measurmentUnit: otherVariantData.measurmentUnit,
            discountPrice: otherVariantData.discountPrice,
            discountType: otherVariantData.discountType,
            productCode: otherVariantData.productCode,
            inventoryQty: otherVariantData.inventoryQty,
            purchasePrice: otherVariantData.purchasePrice,
            b2bProductPrice: otherVariantData.b2bProductPrice,
            productImageArray: otherVariantData.productImageArray,
          };
        }
        return {
          ...data,
        };
      });

      console.log("mergingData", mergingData);
      setVariants([...mergingData]);
    } else if (rowSelection) {
      setVariants(variantsArr);
    } else {
      setVariants([...variantsArr, ...otherVariant]);
    }
  };

  const handleDateChange = (v) => {
    setProductDetails((prev) => ({
      ...prev,
      expiryDate: v,
    }));
  };

  const [barcodeModal, setBarcodeModal] = useState(false);

  const ref1 = useRef();

  const printBarcode = () => {
    var content = document.getElementById("barcodePrint");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    setTimeout(() => {}, 200);
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  const renderBarCode = () => {
    // const canvas = document.createElement("canvas");
    // JsBarcode(canvas, "Hi world!");
    // ref1.current.appendChild(canvas);
    // var canvas = document.getElementById("barcode");
    // JsBarcode(canvas, "Hi world!", {
    //   width: 2,
    // });
    // ref1.current.appendChild(canvas);
  };

  const handleDelete = (data) => {
    setDeleteModal((prev) => {
      return {
        ...prev,
        open: true,
        data: data,
      };
    });
  };

  const handleClick = (data) => {
    deleteProduct(data);
  };

  useHotkeys("alt+n", () => {
    setAddProductModal(true);
  });
  useHotkeys("alt+u", () => {
    setActiveTab("2");
  });
  useHotkeys("alt+t", () => {
    setActiveTab("3");
  });

  // <span
  //   style={{
  //     fontSize: "12px",
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     cursor: "pointer",
  //     gap: 4,
  //     color: colorTextSecondary,
  //     fontWeight: 600,
  //   }}
  //   role="button"
  //   onClick={() => editProduct(data)}
  // >
  //   <RiEditLine color={colorTextSecondary} />
  //   Edit
  // </span>

  const handleNormalProductToVariant = (data) => {
    const rowSelectedProduct = [data];
    handleUpgradeEdit(rowSelectedProduct[0], rowSelectedProduct);
  };

  const menuItems = (data) => {
    const isDeleteAccess = access.deleteProduct(false);
    const items = [
      {
        key: "1",
        icon: <RiDeleteBin6Line color={colorPrimary} />,
        label: isDeleteAccess ? (
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this Product?"
            onConfirm={() => {
              handleClick(data);
            }}
            onCancel={() => {}}
            okText={"Yes"}
            cancelText={"No"}
          >
            <span
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                color: colorPrimary,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Delete
            </span>
          </Popconfirm>
        ) : (
          <span
            role="button"
            onClick={() => {
              access.deleteProduct();
            }}
            style={{
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              color: colorPrimary,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Delete
          </span>
        ),
        style: {
          width: 120,
        },
      },
      {
        key: "2",
        icon: <RiEditLine color={colorTextSecondary} />,
        style: {
          width: 120,
        },
        label: (
          <span
            style={{
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              gap: 4,
              color: colorTextSecondary,
              fontWeight: 600,
            }}
            role="button"
            onClick={() => {
              console.log("data222", data);
              const isAccess = access.editProduct();
              if (!isAccess) {
                return;
              }
              if (rowSelection) {
                setRowSelection(false);
                setRowSelectedProduct([]);
                setNewQty(0);
              }
              setUpgradingToProductData(data);
              editProduct(data);
            }}
          >
            Edit
          </span>
        ),
      },
    ];

    return items;
  };

  const tableColumns = [
    {
      title: "Product Name",
      fixed: "left",
      width: 100,
      render: (rowData) => {
        var isLowStock = rowData.lowStockAlert
          ? rowData.inventoryQty <= rowData.lowStockAlert
          : rowData.inventoryQty <= defaultLowStockAlert;
        return (
          <div>
            <div>{rowData.productName}</div>
            {isLowStock && (
              <div
                style={{
                  background: "#FEF0EF",
                  maxWidth: "120px",
                  margin: "0 auto",
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  justifyContent: "center",
                  lineHeight: 1.5,
                  paddingBlock: 4,
                }}
              >
                <img src={WarningIcon} alt="warning" width={18} height={18} />
                <Typography.Text
                  style={{
                    color: colorPrimary,
                    fontSize: 12,
                  }}
                >
                  Low Stock
                </Typography.Text>
              </div>
            )}
          </div>
        );
      },
      className: "productNameTd",
    },
    {
      title: "Product Mrp",
      dataIndex: "productMrp",
      render: (rowData) => {
        return <span>{currencyFormatter(rowData)}</span>;
      },
    },
    {
      title: "Selling Price",
      dataIndex: "productPrice",
      render: (productPrice) => {
        return <span>{currencyFormatter(productPrice)}</span>;
      },
    },
    {
      title: "Inventory Qty",
      dataIndex: "inventoryQty",
      render: (inventoryQty) => {
        return <span>{parseFloat(inventoryQty)?.toFixed?.(2)}</span>;
      },
    },
    {
      title: "Brand Name",
      render: (rowData) => {
        return <span>{rowData.productBrand ? rowData.productBrand : "-"}</span>;
      },
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Sub Category",
      dataIndex: "subCategory",
    },
    {
      title: "Product Code",
      render: (rowData) => {
        return <span>{rowData.productCode ? rowData.productCode : "-"}</span>;
      },
    },
    {
      title: "EAN Code",
      render: (rowData) => {
        return (
          <span>{rowData.productEANCode ? rowData.productEANCode : "-"}</span>
        );
      },
    },
    {
      title: "Expiration Date",
      render: (rowData) => {
        return (
          <span>
            {rowData.expiryDate
              ? rowData.expiryDate !== "Invalid Date" && rowData.expiryDate
              : "-"}
          </span>
        );
      },
    },
    {
      title: "Make live",
      render: (data) => {
        return (
          <>
            <AntdSwitch
              onChange={(v) => makeProductlive(data, v)}
              disabled={
                data.productPrice === "TBD"
                  ? true
                  : !data.productPrice
                    ? true
                    : false
              }
              checked={data.status === "live"}
            />
          </>
        );
      },
      // customSort: (a, b) => {
      //   if (a.status === "new" || a.status === "ported") {
      //     return 1;
      //   } else {
      //     return -1;
      //   }
      // },
      // defaultSort: "desc",
    },
    {
      title: "Action",
      fixed: "right",
      width: 200,
      render: (data) => {
        return (
          <Dropdown
            getPopupContainer={(trigger) => trigger.parentNode}
            menu={{ items: menuItems(data) }}
            placement="left"
            arrow
            className="dropDownPosition"
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  const upgradeProductColumns = [
    {
      title: "Product Name",
      fixed: "left",
      width: 100,
      render: (rowData) => {
        return (
          <div>
            <div>{rowData.productName}</div>
          </div>
        );
      },
    },
    {
      title: "Product Mrp",
      dataIndex: "productMrp",
      render: (rowData) => {
        return <span>{currencyFormatter(rowData)}</span>;
      },
    },
    {
      title: "Selling Price",
      dataIndex: "productPrice",
      render: (productPrice) => {
        return <span>{currencyFormatter(productPrice)}</span>;
      },
    },
    {
      title: "Brand Name",
      render: (rowData) => {
        return <span>{rowData.productBrand ? rowData.productBrand : "-"}</span>;
      },
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "Sub Category",
      dataIndex: "subCategory",
    },
    {
      title: "Product Code",
      render: (rowData) => {
        return <span>{rowData.productCode ? rowData.productCode : "-"}</span>;
      },
    },
    {
      title: "EAN Code",
      render: (rowData) => {
        return (
          <span>{rowData.productEANCode ? rowData.productEANCode : "-"}</span>
        );
      },
    },
    {
      title: "Measurement",
      render: (rowData) => {
        return (
          <span>
            {rowData.unitOfMeasurment ? rowData.unitOfMeasurment : "-"}
          </span>
        );
      },
    },
  ];

  const exportHead = [
    "Group",
    "Category",
    "Sub Category",
    "Product Brand",
    "Product Name",
    "Product Mrp",
    "Product Price",
    "Measurement Value",
    "Measurement Unit",
    "InventoryQty",
    "ProductEANCode",
    "PurchasePrice",
    "Product Code",
    "Product Tax",
    "Tax Type",
    "Expiry Date",
    "product Hsn Code",
    "product Image Array",
  ];
  const exportValue = [
    "group",
    "category",
    "subCategory",
    "productBrand",
    "productName",
    "productMrp",
    "productPrice",
    "measurmentValue",
    "measurmentUnit",
    "inventoryQty",
    "productEANCode",
    "purchasePrice",
    "productCode",
    "productTax",
    "taxIncExc",
    "expiryDate",
    "productHsnCode",
    "productImageArray",
  ];

  const tabs = [
    {
      label: "Shop Items",
      key: "1",
    },
    {
      label: "Excel Upload",
      key: "2",
    },
    {
      label: "Tax Master",
      key: "3",
    },
    {
      label: "Manage Category",
      key: "4",
    },
  ];

  const handleCheckboxClick = (record, selected, selectedRows, event) => {
    console.log("record", event.target.checked, record);
    const checked = event.target.checked;
    setRowSelectedProduct((prev) => {
      if (checked) {
        return [...prev, record];
      } else {
        return prev.filter((item) => item.productId !== record.productId);
      }
    });
  };

  const toTernary = (value) => {
    return value ? value : "";
  };

  const handleUpdateToVariant = () => {
    new Promise((resolve, reject) => {
      const variant = {};
      console.log("variants11", variants);
      variants.forEach((product, index, arr) => {
        const units = `${toTernary(product.unitOfMeasurment)}${toTernary(
          product.size,
        )}${toTernary(product.color)}`;
        console.log("variant111", variant, units);
        if (!variant.hasOwnProperty(units)) {
          variant[units] = product.productId;
        } else {
          reject(`Variant already exist for Item no ${index + 1}`);
        }
        if (
          !(
            product.size ||
            product.color ||
            (product.measurmentValue && product.measurmentUnit) ||
            product.unitOfMeasurment
          )
        ) {
          reject(
            `Please select size or color or unit of measurment for Item no ${
              index + 1
            }`,
          );
        }
        if (!editProducts.productName) {
          reject(`Product Name is required`);
        }
        // if (!editProducts.category) {
        //   reject(`Category is required`);
        // }
        // if (!editProducts.subCategory) {
        //   reject(`Sub Category is required`);
        // }
        if (!product.productPrice) {
          reject(`Selling price is required for Item no ${index + 1}`);
        }
        if (!product.inventoryQty) {
          reject(`S.Count(Stock Count) is required for Item no ${index + 1}`);
        }
        if (!product.discountPrice && product.discountType) {
          reject(`Discount price is required for Item no ${index + 1}`);
        }
        if (!product.discountType && product.discountPrice) {
          reject(`Discount type is required for Item no ${index + 1}`);
        }
        if (!product.taxId && product.taxIncExc) {
          reject(`Tax is required for Item no ${index + 1}`);
        }
        if (!product.taxIncExc && product.taxId) {
          reject(`Inclusive/Exclusive is required for Item no ${index + 1}`);
        }
        if (product.discountType === "flat" && product.discountPrice) {
          if (
            parseFloat(product.productPrice) < parseFloat(product.discountPrice)
          ) {
            reject(
              `Discount price should not be greater than the selling price for Item no ${
                index + 1
              }`,
            );
          }
        }
        if (
          product.discountType === "flat" &&
          product.discountPrice &&
          product.purchasePrice
        ) {
          if (
            parseFloat(product.purchasePrice) <
            parseFloat(product.discountPrice)
          ) {
            reject(
              `Discount price should not be greater than the Purchase price for Item no ${
                index + 1
              }`,
            );
          }
        }

        if (product.taxIncExc && product.taxId && product.productMrp) {
          var selectedTax = {};
          var taxs = {};
          if (product.taxId) {
            selectedTax = taxList.find(
              (taxObj) => taxObj.taxId.toString() === product.taxId.toString(),
            );
            let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
              (acc, curr) => {
                const taxTypeName =
                  customTaxType.find((customTax) => customTax.taxId === curr)
                    ?.taxName || curr;
                return acc + parseFloat(selectedTax[taxTypeName] || 0);
              },
              0,
            );
            var taxableValue = taxableValueFunc(
              product.productPrice,
              totalTaxPercentage,
              1,
              product.taxIncExc,
            );
            taxs = taxTypeFunc(taxableValue, selectedTax);

            if (parseFloat(product.productMrp) < taxs.itemTotal) {
              reject(
                `Selling price exceeding the MRP after applying tax for Item Number(s):${
                  index + 1
                }`,
              );
            }
          }
        }

        if (
          product.taxIncExc &&
          product.taxId &&
          product.productMrp &&
          product.b2bProductPrice
        ) {
          let selectedTax = {};
          let taxs = {};
          if (product.taxId) {
            selectedTax = taxList.find(
              (taxObj) => taxObj.taxId.toString() === product.taxId.toString(),
            );
            let totalTaxPercentage = selectedTax?.productTaxType?.reduce(
              (acc, curr) => {
                const taxTypeName =
                  customTaxType.find((customTax) => customTax.taxId === curr)
                    ?.taxName || curr;
                return acc + parseFloat(selectedTax[taxTypeName] || 0);
              },
              0,
            );
            let taxableValue = taxableValueFunc(
              product.productPrice,
              totalTaxPercentage,
              1,
              product.taxIncExc,
            );
            taxs = taxTypeFunc(taxableValue, selectedTax);

            if (parseFloat(product.productMrp) < taxs.itemTotal) {
              reject(
                `B2b Selling price exceeding the MRP after applying tax for Item Number(s):${
                  index + 1
                }`,
              );
            }
          }
        }

        if (index === variants.length - 1) {
          resolve(arr);
        }
      });
    })
      .then((result) => {
        const parentProductId = v4();
        let type = [];
        result.forEach((i) => {
          if (i.color && !type.includes("color")) {
            type.push("color");
          }
          if (
            ((i.measurmentValue && i.measurmentUnit) || i.unitOfMeasurment) &&
            !type.includes("UOM")
          ) {
            type.push("UOM");
          }
          if (i.size && !type.includes("size")) {
            type.push("size");
          }
        });

        const updateProductWithParentId = result.map((i) => {
          let unitOfMeasurment = "";
          if (i.measurmentValue && i.measurmentUnit) {
            unitOfMeasurment = `${i.measurmentValue} ${i.measurmentUnit}`;
          }
          let key = [];

          if (i.color) {
            key.push(i.color);
          }
          if ((i.measurmentValue && i.measurmentUnit) || i.unitOfMeasurment) {
            key.push(unitOfMeasurment || i.unitOfMeasurment);
          }
          if (i.size) {
            key.push(i.size);
          }

          return {
            ...i,
            ...(unitOfMeasurment && { unitOfMeasurment: unitOfMeasurment }),
            key: key.join("-"),
            type: type.join("-"),
            parentProductId,
          };
        });

        console.log("updateProductWithParentId", updateProductWithParentId);
        const body = {
          hasVariant: true,
          oldVariants: oldVariants,
          type: "updateOldProduct",
        };
        fetch(
          `${config.newApiGateway}/products/dashboard-products-allproducts`,
          {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
              "x-api-key": `${config.newApiKey}`,

              "Content-Type": "application/json",
            },
          },
        )
          .then((res) => res.json())
          .then(() => {
            addUpdatedProduct(updateProductWithParentId);
            setUpgradingToVariant(false);
          })
          .catch((err) => {
            console.log("err111", err);
            alert("something went wrong please try again");
            setDisabled(false);
          });
      })
      .catch((error) => {
        message.error(error);
      });
  };

  return (
    <>
      <div>
        <div>
          <CustomTabs
            style={{
              marginBottom: "24px",
            }}
            onTabChange={(v) => {
              setActiveTab(v);
            }}
            items={tabs}
            activeKey={activeTab}
          />

          {activeTab === "1" && (
            <>
              {!access.products(false) ? (
                <Alert
                  style={{
                    padding: "20px",
                    textAlign: "center",
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                  type="error"
                />
              ) : (
                <>
                  <Card
                    bodyStyle={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                    style={{
                      marginBottom: 20,
                    }}
                  >
                    <AntdButton
                      type="primary"
                      id="createProductBtn"
                      onClick={() => {
                        const isAccess = access.createProduct();
                        if (!isAccess) {
                          return;
                        }
                        setAddProductModal(true);
                      }}
                    >
                      Create Product
                    </AntdButton>
                  </Card>
                  <CustomTable
                    id={
                      rowSelection
                        ? "tableWithCheckbox"
                        : "tableWithoutCheckbox"
                    }
                    title={"Shop Items"}
                    data={products}
                    columns={tableColumns}
                    style={{
                      minHeight: "500px",
                    }}
                    rowKey={"productId"}
                    csvAccessKey="csvExport"
                    loading={isLoading}
                    excelExport={!rowSelection}
                    exportHead={exportHead}
                    exportValue={exportValue}
                    rowSelection={
                      rowSelection
                        ? {
                            type: "checkbox",
                            hideSelectAll: true,
                            onSelect: handleCheckboxClick,

                            className: "checkboxTd",
                            getCheckboxProps: (record) => {
                              const unitOfMeasurements = [];
                              const productIds = [];
                              rowSelectedProduct.forEach((i) => {
                                if (i.unitOfMeasurment) {
                                  unitOfMeasurements.push(i.unitOfMeasurment);
                                  productIds.push(i.productId);
                                }
                              });
                              return {
                                disabled:
                                  (record.parentProductId ||
                                    !record.unitOfMeasurment ||
                                    unitOfMeasurements.includes(
                                      record.unitOfMeasurment,
                                    )) &&
                                  !productIds.includes(record.productId)
                                    ? true
                                    : false,
                              };
                            },
                            preserveSelectedRowKeys: true,
                          }
                        : undefined
                    }
                    extraAction={
                      <>
                        {!rowSelection && (
                          <>
                            <AntdButton
                              type="primary"
                              onClick={() => {
                                const isAccess = access.bulkUpdatePrice();
                                if (!isAccess) {
                                  return;
                                }
                                props.history.push(
                                  "/dashboard/bulk-price-update",
                                );
                              }}
                              ghost
                            >
                              Update Price
                            </AntdButton>
                            <AntdButton
                              type="primary"
                              onClick={() => {
                                message.info(
                                  "Please select the checkbox that you wish to upgrade.",
                                  4,
                                );
                                setRowSelection(true);
                              }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 5,
                              }}
                              ghost
                            >
                              Merging Products
                              <Tooltip
                                title={
                                  <ul>
                                    <li
                                      style={{
                                        listStyle: "auto",
                                      }}
                                    >
                                      Products which are going to merge should
                                      contain unit of measurement
                                    </li>
                                    <li
                                      style={{
                                        listStyle: "auto",
                                      }}
                                    >
                                      Same unit of measurement cannot be merged
                                    </li>
                                  </ul>
                                }
                              >
                                <AiOutlineInfoCircle size={20} />
                              </Tooltip>
                            </AntdButton>
                          </>
                        )}
                        {rowSelection && (
                          <Space size={"small"}>
                            <AntdButton
                              type="primary"
                              onClick={() => {
                                setRowSelection(false);
                              }}
                              ghost
                            >
                              Cancel
                            </AntdButton>
                            <AntdButton
                              type="primary"
                              onClick={() => {
                                if (rowSelectedProduct.length === 0) {
                                  message.info(
                                    "Please select the checkbox that you wish to update.",
                                  );
                                  return;
                                }
                                if (rowSelectedProduct.length < 2) {
                                  message.info(
                                    "Choose two or more products to upgrade.",
                                  );
                                  return;
                                }
                                handleUpgradeEdit(
                                  rowSelectedProduct[0],
                                  rowSelectedProduct,
                                );
                              }}
                            >
                              Submit
                            </AntdButton>
                          </Space>
                        )}
                      </>
                    }
                  />
                </>
              )}
            </>
          )}
          {activeTab === "2" && (
            <>
              {!access.excelUpload(false) ? (
                <Alert
                  style={{
                    padding: "20px",
                    textAlign: "center",
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                  type="error"
                />
              ) : (
                <>
                  <ProductExcelUpload />
                </>
              )}
            </>
          )}

          {activeTab === "3" && (
            <>
              {!access.taxMaster(false) ? (
                <Alert
                  type="error"
                  style={{
                    padding: "20px",
                    textAlign: "center",
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                />
              ) : (
                <Taxmaster />
              )}
            </>
          )}
          {activeTab === "4" && (
            <>
              {!access.category(false) ? (
                <Alert
                  type="error"
                  style={{
                    padding: "20px",
                    textAlign: "center",
                  }}
                  message="You don't have access, Please contact your administrator to request the appropriate access."
                />
              ) : (
                <AddCategories />
              )}
            </>
          )}

          {/* <div style={{ textAlign: "right", marginBottom: "20px" }}>
            <Button
              variant="outline-danger"
              onClick={() => setAddProductModal(true)}
              style={{
                marginLeft: "20px",
                cursor: "pointer",
              }}
            >
              Add Items
            </Button>
            <Button
              variant="outline-danger"
              style={{
                marginLeft: "20px",
                cursor: "pointer",
              }}
              onClick={() => props.history.push("/dashboard/excel-upload")}
            >
              Excel Upload
            </Button>
            <Button
              variant="outline-danger"
              style={{
                marginLeft: "20px",
                cursor: "pointer",
              }}
              onClick={() =>
                props.history.push("/dashboard/shop-items/tax-master")
              }
            >
              Tax Master
            </Button>
            {shopDetails.shopType !== "Supermarket" &&
              shopDetails.shopType !== "Provisional Store" && (
                <Button
                  variant="outline-danger"
                  style={{
                    marginLeft: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => props.history.push("/dashboard/addCategories")}
                >
                  Manage Categories
                </Button>
              )}
          </div> */}
          {/* <MaterialTable
            columns={[
              {
                render: (data) => {
                  var isLowStock = data.lowStockAlert
                    ? data.inventoryQty <= data.lowStockAlert
                    : data.inventoryQty <= defaultLowStockAlert;

                  return (
                    <div style={{ width: "83px" }}>
                      <div
                        style={{
                          display: "flex",
                          // justifyContent: "space-around",
                        }}
                      >
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => editProduct(data)}
                          title="Edit Item"
                        >
                          <EditIcon />
                        </div>
                        <button
                          style={{
                            outline: "none",
                            backgroundColor: "white",
                            border: "none",
                            fontSize: "15px",
                          }}
                          title="Delete Item"
                          onClick={() => handleDelete(data)}
                          className="delete-btn"
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                      {isLowStock && (
                        <div className="lowStockIndicator">Low Stock</div>
                      )}
                    </div>
                  );
                },
              },

              {
                title: "Product Name",
                field: "productName",

                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: "10px",
                        padding: "0",
                        border: 0,
                        width: "25ch",
                      }}
                      title={data.productName}
                    >
                      {data.productName}
                    </div>
                  );
                },
              },
              {
                title: "Product MRP(${country.CurrencySymbol})",
                render: (data) => {
                  if (data.productMrp === "TBD") return <></>;
                  return (
                    <>
                      {data.productMrp
                        ? currencyFormatter(data.productMrp)
                        : ""}
                    </>
                  );
                },
              },
              {
                title: "Selling Price(${country.CurrencySymbol})",
                render: (data) => {
                  if (data.productPrice === "TBD")
                    return (
                      <label style={{ color: "red", fontSize: "11px" }}>
                        Add selling price to make this product live
                      </label>
                    );
                  return (
                    <>
                      {data.productPrice
                        ? currencyFormatter(data.productPrice)
                        : ""}
                    </>
                  );
                },
              },
              // {
              //   title: "Selling Price(${country.CurrencySymbol})",
              //   field: "productPrice",

              //   type: "currency",
              //   currencySetting: {
              //     locale: "hi-in",
              //     currencyCode: "inr",
              //     minimumFractionDigits: 2,
              //   },
              // },
              {
                title: "Inventory Qty",
                field: "inventoryQty",
              },
              {
                title: "Brand Name",
                field: "productBrand",

                render: (data) => {
                  return (
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: "10px",
                        padding: "0",
                        border: 0,
                        width: "25ch",
                      }}
                      title={data.productBrand}
                    >
                      {data.productBrand}
                    </div>
                  );
                },
              },
              {
                title: "Group",
                field: "group",
                hidden:
                  shopDetails.shopType === "Supermarket" ||
                  shopDetails.shopType === "Provisional Store"
                    ? false
                    : true,
              },
              {
                title: "Category",
                field: "category",
              },
              {
                title: "Sub-Category",
                field: "subCategory",
              },
              {
                title: "Product code",
                field: "productCode",
              },
              {
                title: "EAN Code",
                field: "productEANCode",
              },
              {
                title: "Make live",
                render: (data) => {
                  if (data.status === "new" || data.status === "ported") {
                    return (
                      <>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                disabled={
                                  data.productPrice === "TBD"
                                    ? true
                                    : !data.productPrice
                                    ? true
                                    : false
                                }
                              />
                            }
                            onChange={() => makeProductlive(data)}
                          />
                        </FormGroup>
                      </>
                    );
                  }
                },
                customSort: (a, b) => {
                  if (a.status === "new" || a.status === "ported") {
                    return 1;
                  } else {
                    return -1;
                  }
                },
                defaultSort: "desc",
              },
            ]}
            data={products}
            isLoading={isLoading}
            title="Shop Items"
            icons={tableIcons}
            options={{
              pageSize: 50,
              emptyRowsWhenPaging: false,
              paging: true,
              pageSizeOptions: [10, 20, 50, 100, 500],
              //   rowStyle: (rowData) => {
              //     var isLowStock = rowData.lowStockAlert
              //       ? rowData.inventoryQty <= rowData.lowStockAlert
              //       : false;
              //     if (isLowStock) {
              //       return {
              //         color: "red",
              //       };
              //     }
              //   }
            }}
            components={{
              Pagination: PatchedPagination,
              Toolbar: (prop) => (
                <div>
                  <MTableToolbar {...prop} />
                  <div className="customToolBar">
                    <div className="categoryDropdown">
                      <Button
                        variant="outline-secondary"
                        onClick={() =>
                          props.history.push("/dashboard/bulk-price-update")
                        }
                      >
                        Update Price
                      </Button>
                    </div>
                  </div>
                </div>
              ),
            }}
          /> */}
        </div>
      </div>

      <Modal
        show={false}
        onHide={() => {
          setBarcodeModal(!barcodeModal);
          setGroup([]);
          setCategory([]);
          setSubCategory([]);
        }}
      >
        <Modal.Body>
          <div>
            <iframe
              id="ifmcontentstoprint"
              style={{
                height: 0,
                width: 0,
                position: "absolute",
              }}
            ></iframe>
            <div
              id="barcodePrint"
              style={{
                textAlign: "center",
              }}
            >
              <h1 style={{ fontSize: "15px" }}>Hello CodeSandbox</h1>
              <h2 style={{ fontSize: "15px" }}>
                Start editing to see some magic happen!
              </h2>
              <div>
                <Barcode
                  value="7654345"
                  lineColor="#0aa"
                  width="1px"
                  height="10px"
                  fontSize="5px"
                />
              </div>

              <div id="barcode"></div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            onClick={() => setBarcodeModal(!barcodeModal)}
          >
            Close
          </Button>
          <Button onClick={() => printBarcode()}>Print</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={addProductModal}
        onHide={() => {
          setProductDetails({
            ...INITIAL_STATE,
          });
          setNewQty(0);
          setAddProductModal(false);
          variantResetData();
          setSubCategory([]);
          setImageArrayUrl([]);
          variantResetData();
        }}
        dialogClassName="custom-addproduct-modal"
      >
        <Modal.Header>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ flex: 1 }}>
              <h3>Add Item</h3>
            </div>
            <div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasVariant}
                      onChange={() => setHasVariant(!hasVariant)}
                    />
                  }
                  label="Add Variant"
                />
              </FormGroup>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* <input */}

          <div
            className="flex-row"
            style={{
              marginTop: "0px",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            <div className="add-item-left-flex">
              {shopDetails.shopType === "Supermarket" ||
              shopDetails.shopType === "Provisional Store" ? (
                <div>
                  <div>
                    <p>
                      Group{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="group-select"
                        value={productDetails.group}
                        onChange={(e) =>
                          categorySelector(e.target.value, "add")
                        }
                      >
                        <option value="" disabled>
                          Select group
                        </option>
                        {Object.keys(categoryList).length > 0 && (
                          <>
                            {Object.entries(categoryList.groups).map(
                              ([key, value]) => {
                                return (
                                  <option key={key} value={key}>
                                    {key}
                                  </option>
                                );
                              },
                            )}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                  <div>
                    <div>
                      Category{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </div>
                    <div className="add-item-select">
                      <select
                        id="category-select"
                        value={productDetails.category}
                        onChange={(e) =>
                          subCategorySelector(e.target.value, "add")
                        }
                      >
                        <option value="" disabled>
                          Select category
                        </option>
                        {category.map((data) => {
                          return (
                            <option key={data} value={data}>
                              {data}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div>
                    <p>
                      Sub Category{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="sub-category-select"
                        value={productDetails.subCategory}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            subCategory: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Sub Category
                        </option>
                        {subCategory.map((data) => {
                          return (
                            <option key={data} value={data}>
                              {data}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div>
                    <p>
                      Category{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="category-select"
                        value={productDetails.category}
                        onChange={(e) =>
                          subCategorySelector(e.target.value, "add")
                        }
                      >
                        <option value="" disabled>
                          Select category
                        </option>
                        {Object.entries(categoryList).map(([key, value]) => {
                          return (
                            <option key={key} value={key}>
                              {key}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div>
                    <p>
                      Sub Category{" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="sub-category-select"
                        value={productDetails.subCategory}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            subCategory: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Sub Category
                        </option>
                        {subCategory.map((data) => {
                          return (
                            <option key={data} value={data}>
                              {data}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* {shopDetails.shopType === "Textile" && (
                  <>
                    <p>Choose Size</p>
                    <div className="add-item-select">
                      <select
                        value={productDetails.size}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            size: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Choose Size
                        </option>
                        {collection.map((data) => {
                          return (
                            <option key={data.value} value={data.value}>
                              Size: {data.value} For {data.details}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </>
                )} */}
              <p>Brand Name</p>
              <div className="add-item-select">
                <input
                  type="text"
                  value={productDetails.productBrand}
                  name="productBrand"
                  onChange={inputChangeHandler}
                  placeholder="Enter brand name"
                  maxlength={50}
                />
              </div>
              <p>
                Product Name{" "}
                <span
                  style={{
                    color: "red",
                  }}
                >
                  *
                </span>
              </p>
              <div className="add-item-select">
                <input
                  type="text"
                  value={productDetails.productName}
                  name="productName"
                  onChange={inputChangeHandler}
                  placeholder="Enter product Name"
                  maxLength={40}
                />
              </div>
              {!hasVariant && (
                <>
                  <p>Unit of Measurements</p>
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "65%" }}>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={productDetails.measurmentValue}
                        name="measurmentValue"
                        onChange={inputChangeHandler}
                        placeholder="Enter Measurement value"
                      />
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "30%", marginLeft: "5%" }}
                    >
                      <select
                        id="unit-select"
                        value={productDetails.measurmentUnit}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            measurmentUnit: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          unit
                        </option>
                        {UNIT.map((data) => {
                          return (
                            <option key={data} value={data}>
                              {data}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>
                    Inventory Quantity{" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={productDetails.inventoryQty}
                      name="inventoryQty"
                      onChange={inputChangeHandler}
                      placeholder="Enter Stock Count"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Low Stock Quantity</p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={productDetails.lowStockAlert}
                      name="lowStockAlert"
                      onChange={inputChangeHandler}
                      placeholder="Enter Low Stock Value"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Product EAN Code</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      value={productDetails.productEANCode}
                      name="productEANCode"
                      onChange={inputChangeHandler}
                      placeholder="Enter Product EAN Code"
                    />
                  </div>{" "}
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Product Description</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      value={productDetails.productDescription}
                      name="productDescription"
                      onChange={inputChangeHandler}
                      placeholder="Enter Product Description"
                    />
                  </div>{" "}
                </>
              )}
            </div>

            <div className="add-item-right-flex">
              {!hasVariant && (
                <div className="flex-row">
                  <div style={{ width: "48%" }}>
                    <p>Product MRP({country.CurrencySymbol})</p>
                    <div className="add-item-select">
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={productDetails.productMrp}
                        name="productMrp"
                        onChange={(e) => {
                          if (e.target.val === "")
                            setProductDetails({
                              ...productDetails,
                              productMrp: "",
                            });
                          else {
                            setProductDetails({
                              ...productDetails,
                              productMrp: e.target.value,
                            });
                          }
                        }}
                        placeholder="Enter product MRP"
                      />
                    </div>
                  </div>
                  <div style={{ width: "48%", marginLeft: "4%" }}>
                    <p>
                      Selling price({country.CurrencySymbol}){" "}
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={productDetails.productPrice}
                        name="productPrice"
                        onChange={(e) => {
                          if (e.target.val === "")
                            setProductDetails({
                              ...productDetails,
                              productPrice: "",
                            });
                          else {
                            setProductDetails({
                              ...productDetails,
                              productPrice: e.target.value,
                            });
                          }
                        }}
                        placeholder="Enter selling price"
                      />
                    </div>
                  </div>
                </div>
              )}
              {!hasVariant && shopDetails.advanceSettings?.b2bPricing && (
                <>
                  <p>B2B Selling Price({country.CurrencySymbol})</p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={productDetails.b2bProductPrice}
                      name="b2bProductPrice"
                      onChange={inputChangeHandler}
                      placeholder={`Enter B2B Selling Price(${country.CurrencySymbol})`}
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Purchase Rate({country.CurrencySymbol})</p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={productDetails.purchasePrice}
                      name="purchasePrice"
                      onChange={inputChangeHandler}
                      placeholder={`Enter Purchase Rate(${country.CurrencySymbol})`}
                    />
                  </div>
                </>
              )}
              {/* <p>EAN Code</p>
                <div className="add-item-select">
                  <input
                    type="text"
                    value={productDetails.productEANCode}
                    name="productEANCode"
                    onChange={inputChangeHandler}
                    placeholder="Enter the EAN code of the item"
                  />
                </div> */}
              {!hasVariant && (
                <>
                  <p>Discount</p>
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "65%" }}>
                      <input
                        value={productDetails.discountPrice}
                        name="discountPrice"
                        onChange={inputChangeHandler}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Item level discount"
                      />
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "30%", marginLeft: "5%" }}
                    >
                      <select
                        id="discountType-select"
                        value={productDetails.discountType}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            discountType: e.target.value,
                          })
                        }
                      >
                        <option value="">Type </option>
                        <option value="flat">Flat</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>HSN Code</p>
                  <div className="add-item-select">
                    <input
                      // style={{ width: "350px" }}
                      type="text"
                      value={productDetails.productHsnCode}
                      name="productHsnCode"
                      onChange={inputChangeHandler}
                      placeholder="Enter the HSN code of the item"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Tax(%)</p>
                  {/* <div className="add-item-select">
                  <input
                    value={productDetails.tax}
                    name="tax"
                    onChange={inputChangeHandler}
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    placeholder="Tax"
                  />
                </div> */}
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "50%" }}>
                      <select
                        id="tax-select"
                        value={productDetails.taxId}
                        name="taxId"
                        onChange={inputChangeHandler}
                        onWheel={(e) => e.target.blur()}
                      >
                        <option value="">Select Tax</option>
                        {taxList.map((tax, index) => (
                          <option key={index} value={tax.taxId}>
                            {tax.taxName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "50%", marginLeft: "1rem" }}
                    >
                      <select
                        id="taxType-select"
                        value={productDetails.taxIncExc}
                        onChange={(e) =>
                          setProductDetails({
                            ...productDetails,
                            taxIncExc: e.target.value,
                          })
                        }
                      >
                        <option value="">Inclusive/Exclusive </option>
                        <option value="inclusive">Inclusive</option>
                        <option value="exclusive">Exclusive</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              {/* {shopDetails.shopType === "Jewellery Shop" && !hasVariant && (
                  <div className="flex-row">
                    <div style={{ width: "48%" }}>
                      <p>Product productWastage(%)</p>
                      <div className="add-item-select">
                        <input
                          // style={{ width: "45%" }}
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          value={productDetails.productWastage}
                          name="productWastage"
                          onChange={inputChangeHandler}
                          placeholder="Enter productWastage(%)"
                        />
                      </div>
                    </div>
                    <div style={{ width: "48%", marginLeft: "4%" }}>
                      <p>Product productLabour(%)</p>
                      <div className="add-item-select">
                        <input
                          // style={{ width: "45%" }}
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          value={productDetails.productLabour}
                          name="productLabour"
                          onChange={inputChangeHandler}
                          placeholder="Enter Labour(%)"
                        />
                      </div>
                    </div>
                  </div>
                )} */}
              {!hasVariant && (
                <>
                  <p>Product Code</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      onWheel={(e) => e.target.blur()}
                      value={productDetails.productCode}
                      name="productCode"
                      onChange={inputChangeHandler}
                      placeholder="Enter ProductCode"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Expiration date</p>
                  <div className="add-item-select">
                    <DatePicker
                      type="date"
                      inputReadOnly={true}
                      style={{ width: "100%", borderRadius: "4px" }}
                      value={productDetails.expiryDate}
                      name="expiryDate"
                      disabledDate={disabledDate}
                      onChange={handleDateChange}
                    />
                  </div>
                </>
              )}
              {shopDetails.shopType === "Mobile" && !hasVariant && (
                <div className="flex-row">
                  <div style={{ width: "48%" }}>
                    <p>IMEI1</p>
                    <div className="add-item-select">
                      <input
                        // style={{ width: "45%" }}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={productDetails.imei1}
                        name="imei1"
                        onChange={inputChangeHandler}
                        placeholder="Enter IMEI1"
                      />
                    </div>
                  </div>
                  <div style={{ width: "48%", marginLeft: "4%" }}>
                    <p>IMEI2</p>
                    <div className="add-item-select">
                      <input
                        // style={{ width: "45%" }}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={productDetails.imei2}
                        name="imei2"
                        onChange={inputChangeHandler}
                        placeholder="Enter imei2"
                      />
                    </div>
                  </div>
                </div>
              )}
              {(shopDetails.shopType === "Supermarket" ||
                shopDetails.shopType === "Provisional Store" ||
                shopDetails.shopType === "Bakery" ||
                shopDetails.shopType === "Restaurant" ||
                shopDetails.shopType === "Juice Shop" ||
                shopDetails.shopType === "Tea Shop" ||
                shopDetails.shopType === "Sweets and Snacks") && (
                <div className="flex-row">
                  <div>
                    <input
                      type="radio"
                      value="Veg"
                      id="veg"
                      name="vegNonVeg"
                      onChange={(e) =>
                        setProductDetails({
                          ...productDetails,
                          vegNonVeg: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="veg">Veg</label>
                  </div>
                  <div style={{ marginLeft: "10%" }}>
                    <input
                      type="radio"
                      value="Non-Veg"
                      id="nonVeg"
                      name="vegNonVeg"
                      onChange={(e) =>
                        setProductDetails({
                          ...productDetails,
                          vegNonVeg: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="nonVeg">Non Veg</label>
                  </div>
                </div>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={productDetails.frequentPriceChange}
                      onChange={() =>
                        setProductDetails({
                          ...productDetails,
                          frequentPriceChange:
                            !productDetails.frequentPriceChange,
                        })
                      }
                    />
                  }
                  label="Price changes frequently"
                />
              </FormGroup>
              {!hasVariant && (
                <>
                  <p>Choose Product Image(Maximum 8 image)</p>
                  <div>
                    <input
                      ref={ref}
                      type="file"
                      accept="image/png, image/jpg, image/gif"
                      onChange={handleImageUpload}
                      multiple
                    />
                  </div>
                  {uploading ? (
                    <div
                      class="spinner-border text-danger"
                      style={{ marginTop: "10px" }}
                    ></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {imageArrayUrl.map((data) => {
                        return (
                          <>
                            <div
                              key={data}
                              style={{
                                margin: "5px",
                                border: "1px solid grey",
                                borderRadius: "10px",
                              }}
                            >
                              <img
                                width={75}
                                height={75}
                                style={{ borderRadius: "10px" }}
                                src={data}
                                alt="Product Image"
                              />
                            </div>
                            <div onClick={() => removeImage(data)}>
                              <CancelIcon
                                style={{
                                  marginTop: "0px",
                                  marginLeft: "-25px",
                                  color: "red",
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {hasVariant && (
            <div style={{ display: "flex" }}>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 0px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Unit of Measurement</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("UOM");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px", marginBottom: "90px" }}>
                    {uomArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 3px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label>{data}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "UOM")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 30px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Size Info</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("SIZE");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px" }}>
                    {sizeArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 3px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label>{data}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "SIZE")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 30px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Color Details</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("COLOR");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px" }}>
                    {colorArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 3px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label
                            style={{
                              margin: "1px",
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              border: "2px solid grey",
                              backgroundColor: `${data}`,
                            }}
                          ></label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              marginTop: "-15px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "COLOR")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          {hasVariant && variants.length > 0 && (
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Item No.</th>
                  <th>Color/UOM/Size</th>
                  <th>Image</th>
                  <th>MRP()</th>
                  <th>
                    S.Price({country.CurrencySymbol})
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </th>
                  {shopDetails.advanceSettings?.b2bPricing && (
                    <th>B2B-S.Price({country.CurrencySymbol})</th>
                  )}
                  <th>
                    S.Count{" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </th>
                  <th>Purchase Price({country.CurrencySymbol}) </th>
                  <th>EAN Code</th>
                  <th>Product Code</th>
                  <th>Product Description</th>
                  <th>Discount</th>
                  <th>HSN Code</th>
                  <th>Tax(%)</th>
                  {shopDetails.shopType === "Jewellery Shop" && (
                    <>
                      <th>Wastage(%)</th>
                      <th>Labour(%)</th>
                    </>
                  )}
                  <th>Inclusive/Exclusive</th>
                  <th>Expiration Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {variants.map((productData, index) => (
                  <tr key={productData.productId}>
                    <td style={{ verticalAlign: "middle" }}>{index + 1}.</td>
                    <td style={{ verticalAlign: "middle", width: "300px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {productData.color && (
                          <>
                            <label
                              style={{
                                // marginBottom: "-10px",
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                border: "2px solid grey",
                                backgroundColor: `${productData.color}`,
                              }}
                            >
                              {" "}
                            </label>
                          </>
                        )}
                        {productData.unitOfMeasurment && (
                          <label
                            style={{
                              margin: "5px",
                            }}
                          >
                            {productData.unitOfMeasurment}{" "}
                          </label>
                        )}
                        {productData.size && (
                          <label
                            style={{
                              margin: "5px",
                            }}
                          >
                            {productData.size}{" "}
                          </label>
                        )}
                      </div>
                    </td>
                    <td style={{ width: "150px", verticalAlign: "middle" }}>
                      {productData.productImageArray &&
                        productData.productImageArray?.length < 2 && (
                          <>
                            {uploading &&
                            loadingId === productData.productId ? (
                              <div
                                class="spinner-border text-danger"
                                style={{ marginTop: "10px" }}
                              ></div>
                            ) : (
                              <>
                                <div
                                  style={{
                                    border: "2px dotted black",
                                    cursor: "pointer",
                                    width: "70px",
                                  }}
                                >
                                  <label
                                    htmlFor={`variantImage${index}`}
                                    style={{
                                      cursor: "pointer",
                                      margin: "3px",
                                    }}
                                  >
                                    <AddPhotoAlternate />
                                    Add
                                  </label>
                                </div>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id={`variantImage${index}`}
                                  style={{
                                    display: "none",
                                  }}
                                  onChange={(e) => {
                                    variantImageUpload(e, productData);
                                  }}
                                  ref={ref}
                                  multiple
                                />
                              </>
                            )}
                          </>
                        )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "50%",
                        }}
                      >
                        {productData?.productImageArray
                          ?.filter(Boolean)
                          .map((data) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "5px",
                                }}
                              >
                                <div
                                  style={{
                                    borderRadius: "10px",
                                  }}
                                >
                                  <img
                                    width={50}
                                    height={50}
                                    style={{ borderRadius: "10px" }}
                                    src={data}
                                    alt="Product Image"
                                  />
                                </div>
                                <div
                                  onClick={() =>
                                    removeVariantImage(data, productData)
                                  }
                                >
                                  <CancelIcon
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "-25px",
                                      color: "red",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productMrp}
                        placeholder="MRP"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productMrp"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productPrice}
                        placeholder="Selling Price"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="productPrice"
                      />
                    </td>
                    {shopDetails.advanceSettings?.b2bPricing && (
                      <td style={{ verticalAlign: "middle" }}>
                        <input
                          value={productData.b2bProductPrice}
                          placeholder="B2B Selling Price"
                          style={{ width: "100px" }}
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="b2bProductPrice"
                        />
                      </td>
                    )}
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.inventoryQty}
                        placeholder="Stock Count"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            parseFloat(e.target.value),
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="inventoryQty"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={
                          productData.purchasePrice
                            ? productData.purchasePrice
                            : productData.purchasePrice
                        }
                        placeholder="Purchase Price"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="purchasePrice"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productEANCode}
                        placeholder="EAN Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productEANCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productCode}
                        placeholder="Product Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productDescription}
                        placeholder="Product Description"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productDescription"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.discountPrice}
                        placeholder="Discount Amount"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="discountPrice"
                      />
                      <div>
                        <select
                          id="discountType-select"
                          defaultValue=""
                          name="discountType"
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                        >
                          <option value="">Type </option>
                          <option value="flat">Flat</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productHsnCode}
                        placeholder="HSN Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productHsnCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <div>
                        <select
                          id="tax-select"
                          defaultValue="default"
                          name="taxId"
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                        >
                          <option value="">Select Tax </option>
                          {taxList.map((tax) => (
                            <option key={tax.taxId} value={tax.taxId}>
                              {tax.taxName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <select
                        id="taxType-select"
                        defaultValue="default"
                        name="taxIncExc"
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                      >
                        <option value="">Select Inclusive/Exclusive </option>
                        <option value="inclusive">Inclusive</option>
                        <option value="exclusive">Exclusive</option>
                      </select>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <DatePicker
                        type="date"
                        inputReadOnly={true}
                        style={{ width: "150px", borderRadius: "4px" }}
                        value={productData.expiryDate}
                        name="expiryDate"
                        disabledDate={disabledDate}
                        onChange={(v) =>
                          handleVariantInputChange(
                            "expiryDate",
                            v,
                            productData.productId,
                          )
                        }
                      />
                    </td>
                    {/* {shopDetails.shopType === "Jewellery Shop" && (
                        <>
                          <td style={{ verticalAlign: "middle" }}>
                            <input
                              value={productData.productWastage}
                              placeholder="Wastage"
                              style={{ width: "100px" }}
                              onChange={(e) =>
                                handleVariantInputChange(
                                  e.target.name,
                                  e.target.value,
                                  productData.productId
                                )
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              name="productWastage"
                            />
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <input
                              value={productData.productLabour}
                              placeholder="Labour Charge"
                              style={{ width: "100px" }}
                              onChange={(e) =>
                                handleVariantInputChange(
                                  e.target.name,
                                  e.target.value,
                                  productData.productId
                                )
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              name="productLabour"
                            />
                          </td>
                        </>
                      )} */}
                    <td style={{ verticalAlign: "middle" }}>
                      <Button
                        onClick={() =>
                          handleRemoveVariant(productData.productId)
                        }
                        size="sm"
                        variant="outline-danger"
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-warning"
            disabled={disabled}
            onClick={() => {
              setGroup([]);
              setCategory([]);
              setSubCategory([]);
              setImageArrayUrl([]);
              setAddProductModal(false);
              variantResetData();
            }}
          >
            Close
          </Button>
          <Button disabled={disabled} onClick={() => addProduct()}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={variantModal}
        onHide={() => {
          setVariantModal(!variantModal);
          setGroup([]);
          setCategory([]);
          setSubCategory([]);
          setUpgradingToVariant(false);
        }}
        centered
        scrollable={false}
      >
        <Modal.Header>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h3>
              {variantType === "UOM"
                ? "Unit Info"
                : variantType === "SIZE"
                  ? "Size Info"
                  : "Color Detils"}
            </h3>
            <HighlightOffIcon
              style={{ cursor: "pointer", fontSize: "30px" }}
              onClick={() => setVariantModal(!variantModal)}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {variantType === "UOM" ? (
            <div className="flex-row">
              <div className="add-item-select" style={{ width: "65%" }}>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={variantUnitValue}
                  onChange={(e) => setVariantUnitValue(e.target.value)}
                  placeholder="Enter Measurement value"
                />
              </div>
              <div
                className="add-item-select"
                style={{ width: "30%", marginLeft: "5%" }}
              >
                <select
                  id="unit-select"
                  value={variantUnit}
                  onChange={(e) => setVariantUnit(e.target.value)}
                >
                  <option value="" disabled>
                    unit
                  </option>
                  {UNIT.map((data) => {
                    return (
                      <option key={data} value={data}>
                        {data}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          ) : (
            <>
              {variantType === "SIZE" ? (
                <>
                  <div className="add-item-select">
                    <input
                      type="text"
                      onWheel={(e) => e.target.blur()}
                      value={variantSize}
                      onChange={(e) => setVariantSize(e.target.value)}
                      placeholder="Enter the size"
                    />
                  </div>
                  <label
                    style={{
                      fontSize: "15px",
                      marginTop: "-50px",
                      color: "grey",
                    }}
                  >
                    Eg: Small
                  </label>
                </>
              ) : (
                <div>
                  {colorPickerType === "preset" ? (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                      }}
                    >
                      {colorPickerArray.map((data) => {
                        if (data === variantColor) {
                          return (
                            <div
                              key={data}
                              style={{
                                margin: "12px",
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                border: "5px solid grey",
                                backgroundColor: `${data}`,
                                cursor: "pointer",
                              }}
                              onClick={() => setVariantColor("")}
                            ></div>
                          );
                        }
                        return (
                          <div
                            key={data}
                            style={{
                              margin: "12px",
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                              border: "2px solid grey",
                              backgroundColor: `${data}`,
                              cursor: "pointer",
                            }}
                            onClick={() => handleColorPick(data)}
                          ></div>
                        );
                      })}
                      <br />
                    </div>
                  ) : (
                    <div style={{ width: "20px" }}>
                      <SketchPicker
                        width={300}
                        color={variantColor}
                        onChangeComplete={(color) => setVariantColor(color.hex)}
                      />
                    </div>
                  )}
                  <div>
                    <Button
                      variant="outline-danger"
                      style={{ margin: "20px" }}
                      onClick={() =>
                        setColorPickerType(
                          colorPickerType === "preset" ? "custom" : "preset",
                        )
                      }
                    >
                      {colorPickerType === "preset" ? "Custom" : "Preset"}
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" onClick={() => addVariant()}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={editProductModal}
        dialogClassName="custom-addproduct-modal"
        onHide={() => {
          setVariants([]);
          variantResetData();
          variantResetData();
          setEditProductModal(false);
          setImageArrayUrl([]);
          setNewQty(0);
          setUpgradingToVariant(false);
        }}
      >
        <Modal.Header>
          <h3>{rowSelection ? "Merging Product" : "Edit Product"}</h3>
          <span>
            {!isUpgradingToVariant && hasVariant ? null : (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="upgrade-to-variant"
                      checked={isUpgradingToVariant}
                      onChange={(v) => {
                        const value = v.target.checked;
                        if (value) {
                          setUpgradingToVariant(true);
                          handleNormalProductToVariant(upgradingToProductData);
                        } else {
                          setHasVariant(false);
                          setUpgradingToVariant(false);
                        }
                      }}
                    />
                  }
                  label="Upgrade To Variant"
                />
              </FormGroup>
            )}
          </span>
        </Modal.Header>
        <Modal.Body>
          <div
            id="variant-modal"
            className="flex-row"
            style={{
              marginTop: "0px",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            <div className="add-item-left-flex">
              {shopDetails.shopType === "Supermarket" ||
              shopDetails.shopType === "Provisional Store" ? (
                <div>
                  <div>
                    <p>Select group</p>
                    <div className="add-item-select">
                      <select
                        id="group-select"
                        value={editProducts.group}
                        onChange={(e) => {
                          categorySelector(e.target.value, "edit");
                        }}
                      >
                        <option value="" disabled>
                          Select group
                        </option>
                        {Object.keys(categoryList).length > 0 && (
                          <>
                            {Object.entries(categoryList.groups).map(
                              ([key, value]) => (
                                <option key={key} value={key}>
                                  {key}
                                </option>
                              ),
                            )}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                  <div>
                    <p>Select Category</p>
                    <div className="add-item-select">
                      <select
                        id="category-select"
                        value={editProducts.category.toUpperCase()}
                        onChange={(e) => {
                          subCategorySelector(e.target.value, "edit");
                        }}
                      >
                        <option value="" disabled>
                          Select category
                        </option>
                        {category.map((key) => (
                          <option key={key} value={key}>
                            {key}
                          </option>
                        ))}
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <p>Choose Sub Category</p>
                    <div className="add-item-select">
                      <select
                        id="sub-category-select"
                        value={editProducts.subCategory}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            subCategory: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Sub Category
                        </option>
                        {subCategory.map((data) => (
                          <option key={data} value={data}>
                            {data}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div>
                    <p>
                      Select Category <span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="category-select"
                        value={editProducts.category.toUpperCase()}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            category: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select category
                        </option>
                        {Object.entries(categoryList).map(([key, value]) => (
                          <option key={key} value={key.toUpperCase()}>
                            {key}
                          </option>
                        ))}
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <p>
                      Choose Sub Category{" "}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="add-item-select">
                      <select
                        id="sub-category-select"
                        value={editProducts.subCategory.toLowerCase()}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            subCategory: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Sub Category
                        </option>
                        {subCategory.map((data) => {
                          return (
                            <option key={data} value={data.toLowerCase()}>
                              {data}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {/* {shopDetails.shopType === "Textile" && !hasVariant && (
                  <div>
                    <p>Size</p>
                    <div className="add-item-select">
                      <select
                        defaultValue={editProducts.size}
                        onChange={(e) => {
                          setEditProducts({
                            ...editProducts,
                            size: e.target.value,
                          });
                        }}
                      >
                        <option value="default" disabled>
                          Choose Size
                        </option>
                        {collection.map((data) => {
                          return (
                            <option key={data.value} value={data.value}>
                              Size: {data.value} For {data.details}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )} */}
              <p>Brand Name</p>
              <div className="add-item-select">
                <input
                  placeholder="Enter brand Name"
                  value={editProducts.productBrand}
                  onChange={(e) =>
                    setEditProducts({
                      ...editProducts,
                      productBrand: e.target.value,
                    })
                  }
                />
              </div>
              <p>
                Product Name
                <span
                  style={{
                    color: "red",
                  }}
                >
                  *
                </span>
              </p>
              <div className="add-item-select">
                <input
                  placeholder="enter product Name"
                  value={editProducts.productName}
                  maxlength={40}
                  onChange={(e) =>
                    setEditProducts({
                      ...editProducts,
                      productName: e.target.value,
                    })
                  }
                />
              </div>
              {!hasVariant && (
                <>
                  <p>Unit of Measurement</p>
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "65%" }}>
                      <input
                        type="number"
                        placeholder="Measurement"
                        value={editProducts.measurmentValue}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            measurmentValue: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "30%", marginLeft: "5%" }}
                    >
                      <select
                        id="unit-select"
                        value={editProducts.measurmentUnit}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            measurmentUnit: e.target.value,
                          })
                        }
                      >
                        <option value="">unit</option>
                        {UNIT.map((data) => (
                          <option key={data} value={data}>
                            {data}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Product EAN Code</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      value={editProducts.productEANCode}
                      name="productEANCode"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          productEANCode: e.target.value,
                        })
                      }
                      placeholder="Enter Product EAN Code"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Product Description</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      value={editProducts.productDescription}
                      name="productDescription"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          productDescription: e.target.value,
                        })
                      }
                      placeholder="Enter product description"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Existing Inventory Quantity</p>
                  <div className="add-item-select">
                    <input
                      value={editProducts.existingInventoryQty}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled
                    />
                  </div>
                </>
              )}
              {!hasVariant && editProducts.productType === "service" && (
                <>
                  <p>Duration</p>
                  <div className="add-item-select">
                    <select
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          duration: e.target.value,
                        })
                      }
                      value={editProducts.duration}
                    >
                      <option defaultChecked>Choose duration</option>
                      <option key="15" value="15">
                        15
                      </option>
                      <option key="30" value="30">
                        30
                      </option>
                      <option key="45" value="45">
                        45
                      </option>
                      <option key="60" value="60">
                        60
                      </option>
                      <option key="90" value="90">
                        90
                      </option>
                      <option key="120" value="120">
                        120
                      </option>
                    </select>
                  </div>
                </>
              )}
            </div>
            <div className="add-item-right-flex">
              {!hasVariant && (
                <>
                  <p>Inventory Quantity</p>
                  <div className="add-item-select">
                    <input
                      placeholder="Update inventory Quantity"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        setEditProducts({
                          ...editProducts,
                          inventoryQty: e.target.value,
                        });
                        setNewQty(e.target.value);
                      }}
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Low Stock Quantity</p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={editProducts.lowStockAlert}
                      name="lowStockAlert"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          lowStockAlert: e.target.value,
                        })
                      }
                      placeholder="Enter Low Stock Value"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <div className="flex-row">
                  <div style={{ width: "48%" }}>
                    <p>Product MRP({country.CurrencySymbol})</p>
                    <div className="add-item-select">
                      <input
                        placeholder={`Enter product MRP(${country.CurrencySymbol})`}
                        value={editProducts.productMrp}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            productMrp: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  {/* </div> */}
                  <div style={{ width: "48%", marginLeft: "4%" }}>
                    <p>
                      Selling price ({country.CurrencySymbol})
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    </p>
                    <div className="add-item-select">
                      <input
                        placeholder="Enter product selling price"
                        value={editProducts.productPrice}
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            productPrice: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {!hasVariant && shopDetails.advanceSettings?.b2bPricing && (
                <>
                  <p>B2B Selling Price({country.CurrencySymbol})</p>
                  <div className="add-item-select">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={editProducts.b2bProductPrice}
                      name="b2bProductPrice"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          b2bProductPrice: e.target.value,
                        })
                      }
                      placeholder={`Enter B2B Selling Price(${country.CurrencySymbol})`}
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Purchase Rate({country.CurrencySymbol})</p>
                  <div className="add-item-select">
                    <input
                      placeholder={`Enter Purchase Rate(${country.CurrencySymbol})`}
                      value={editProducts.purchasePrice}
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          purchasePrice: e.target.value,
                        })
                      }
                    />
                  </div>
                </>
              )}
              {/* <p>EAN Code</p>
                <div className="add-item-select">
                  <input
                    placeholder="Enter product EAN code"
                    value={editProducts.productEANCode}
                    onChange={(e) =>
                      setEditProducts({
                        ...editProducts,
                        productEANCode: e.target.value,
                      })
                    }
                  />
                </div> */}
              {!hasVariant && (
                <>
                  <p>Discount</p>
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "65%" }}>
                      <input
                        value={editProducts.discountPrice}
                        name="discountPrice"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            discountPrice: e.target.value,
                          })
                        }
                        placeholder="Enter Item level discount"
                      />
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "30%", marginLeft: "5%" }}
                    >
                      <select
                        id="discountType-select"
                        value={editProducts.discountType}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            discountType: e.target.value,
                          })
                        }
                      >
                        <option value="">Type </option>
                        <option value="flat">Flat</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>HSN Code</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      value={editProducts.productHsnCode}
                      name="productHsnCode"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          productHsnCode: e.target.value,
                        })
                      }
                      placeholder="Enter the HSN code of the item"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>
                    Tax(%){" "}
                    {(editProducts.taxId || editProducts.taxIncExc) && (
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        *
                      </span>
                    )}
                  </p>
                  <div className="flex-row">
                    <div className="add-item-select" style={{ width: "50%" }}>
                      <select
                        id="tax-select"
                        name="taxId"
                        value={editProducts.taxId}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            taxId: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Tax </option>
                        {taxList.map((tax) => (
                          <option key={tax.taxId} value={tax.taxId}>
                            {tax.taxName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className="add-item-select"
                      style={{ width: "50%", marginLeft: "1rem" }}
                    >
                      <select
                        id="taxType-select"
                        value={editProducts.taxIncExc}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            taxIncExc: e.target.value,
                          })
                        }
                      >
                        <option value="">Inclusive/Exclusive </option>
                        <option value="inclusive">Inclusive</option>
                        <option value="exclusive">Exclusive</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              {/* {shopDetails.shopType === "Jewellery Shop" && !hasVariant && (
                  <div className="flex-row">
                    <div style={{ width: "48%" }}>
                      <p>Product Wastage(%)</p>
                      <div className="add-item-select">
                        <input
                          placeholder="Enter product productWastage"
                          value={editProducts.productWastage}
                          onChange={(e) =>
                            setEditProducts({
                              ...editProducts,
                              productWastage: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div style={{ width: "48%", marginLeft: "4%" }}>
                      <p>Product Labour(%)</p>
                      <div className="add-item-select">
                        <input
                          placeholder="Enter product Labour"
                          value={editProducts.productLabour}
                          onChange={(e) =>
                            setEditProducts({
                              ...editProducts,
                              productLabour: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                )} */}
              {!hasVariant && (
                <>
                  <p>Product Code</p>
                  <div className="add-item-select">
                    <input
                      type="text"
                      onWheel={(e) => e.target.blur()}
                      value={editProducts.productCode}
                      name="productCode"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          productCode: e.target.value,
                        })
                      }
                      placeholder="Enter ProductCode"
                    />
                  </div>
                </>
              )}
              {!hasVariant && (
                <>
                  <p>Expiration date</p>
                  <div className="add-item-select">
                    <DatePicker
                      // inputReadOnly={true}
                      getPopupContainer={(trigger) => trigger.parentElement}
                      value={
                        !!(
                          editProducts.expiryDate !== "Invalid Date" &&
                          editProducts.expiryDate
                        )
                          ? dayjs(editProducts.expiryDate)
                          : ""
                      }
                      disabledDate={disabledDate}
                      style={{
                        width: "100%",
                      }}
                      format="DD-MM-YYYY"
                      name="expiryDate"
                      onChange={(v) => {
                        setEditProducts((prev) => ({
                          ...prev,
                          expiryDate: dayjs(v).format("YYYY-MM-DD"),
                        }));
                      }}
                    />
                  </div>
                </>
              )}
              {shopDetails.shopType === "Mobile" && !hasVariant && (
                <div className="flex-row">
                  <div style={{ width: "48%" }}>
                    <p>IMEI1</p>
                    <div className="add-item-select">
                      <input
                        placeholder="Enter IMEI1"
                        value={editProducts.imei1}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            imei1: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div style={{ width: "48%", marginLeft: "4%" }}>
                    <p>IMEI2</p>
                    <div className="add-item-select">
                      <input
                        placeholder="Enter IMEI2"
                        value={editProducts.imei2}
                        onChange={(e) =>
                          setEditProducts({
                            ...editProducts,
                            imei2: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {(shopDetails.shopType === "Supermarket" ||
                shopDetails.shopType === "Provisional Store" ||
                shopDetails.shopType === "Bakery" ||
                shopDetails.shopType === "Restaurant" ||
                shopDetails.shopType === "Juice Shop" ||
                shopDetails.shopType === "Tea Shop" ||
                shopDetails.shopType === "Sweets and Snacks") && (
                <div className="flex-row">
                  <div>
                    <input
                      type="radio"
                      value="Veg"
                      checked={editProducts.vegNonVeg === "Veg"}
                      id="veg"
                      name="vegNonVeg"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          vegNonVeg: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="veg">Veg</label>
                  </div>
                  <div style={{ marginLeft: "10%" }}>
                    <input
                      type="radio"
                      checked={editProducts.vegNonVeg === "Non-Veg"}
                      value="Non-Veg"
                      id="nonVeg"
                      name="vegNonVeg"
                      onChange={(e) =>
                        setEditProducts({
                          ...editProducts,
                          vegNonVeg: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="nonVeg">Non-Veg</label>
                  </div>
                </div>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={editProducts.frequentPriceChange}
                      onChange={() =>
                        setEditProducts({
                          ...editProducts,
                          frequentPriceChange:
                            !editProducts.frequentPriceChange,
                        })
                      }
                    />
                  }
                  label="Price changes frequently"
                />
              </FormGroup>
              {!hasVariant && (
                <>
                  <p>Choose Product Image</p>
                  <div>
                    <input
                      ref={ref}
                      type="file"
                      accept="image/png, image/jpg, image/gif"
                      onChange={handleImageUpload}
                      multiple
                    />
                  </div>
                  {uploading ? (
                    <div
                      class="spinner-border text-danger"
                      style={{ marginTop: "10px" }}
                    ></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {imageArrayUrl.map((data) => {
                        return (
                          <>
                            <div
                              key={data}
                              style={{
                                margin: "5px",
                                border: "1px solid grey",
                                borderRadius: "10px",
                              }}
                            >
                              <img
                                width={75}
                                height={75}
                                src={data}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                                alt="Product"
                              />
                            </div>
                            <div onClick={() => removeImage(data)}>
                              <CancelIcon
                                style={{
                                  marginTop: "0px",
                                  marginLeft: "-25px",
                                  color: "red",
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {hasVariant && (
            <div style={{ display: "flex" }}>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 0px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Unit of Measurement</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("UOM");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px", marginBottom: "90px" }}>
                    {uomArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 5px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label>{data}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "UOM")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 30px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Size Info</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("SIZE");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px" }}>
                    {sizeArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 3px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label>{data}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "SIZE")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="unitOfMeasurementCard">
                <div style={{ margin: "20px 30px 30px 50px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Color Details</label>
                    </div>
                    <div>
                      <Button
                        style={{ margin: "-5px 5px 5px 5px" }}
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          setVariantModal(!variantModal);
                          setVariantType("COLOR");
                        }}
                      >
                        Add
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: "200px" }}>
                    {colorArray.map((data) => (
                      <div
                        key={data}
                        style={{
                          padding: "3px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid rgb(194, 194, 194)",
                            padding: "0px 3px 0px 5px",
                            borderRadius: "17px",
                            fontSize: "12px",
                          }}
                        >
                          <label
                            style={{
                              margin: "1px",
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              border: "2px solid grey",
                              backgroundColor: `${data}`,
                            }}
                          ></label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "5px",
                              marginTop: "-15px",
                              cursor: "pointer",
                              color: "rgb(111, 111, 111)",
                            }}
                            onClick={() => deleteVariantData(data, "COLOR")}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
          {hasVariant && variants.length > 0 && (
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Item No.</th>
                  <th>Color/UOM/Size</th>
                  <th>Image</th>
                  <th>MRP({country.CurrencySymbol})</th>
                  <th>
                    S.Price({country.CurrencySymbol}){" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </th>
                  {shopDetails.advanceSettings?.b2bPricing && (
                    <th>B2B-S.Price({country.CurrencySymbol})</th>
                  )}
                  <th>
                    S.Count{" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      *
                    </span>
                  </th>
                  <th>Purchase Price({country.CurrencySymbol})</th>
                  <th>EAN Code</th>
                  <th>Product Code</th>
                  <th>Product Description</th>
                  <th>Discount</th>
                  <th>HSN Code</th>
                  <th>Tax(%)</th>
                  {shopDetails.shopType === "Jewellery Shop" && (
                    <>
                      <th>Wastage(%)</th>
                      <th>Labour(%)</th>
                    </>
                  )}
                  <th>Inclusive/Exclusive</th>
                  <th>Expiration Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {variants.map((productData, index) => (
                  <tr key={productData.productId}>
                    <td style={{ verticalAlign: "middle" }}>{index + 1}.</td>
                    <td
                      style={{
                        verticalAlign: "middle",
                        minWidth: "220px",
                        position: "relative",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <EditUnit
                          rowSelection={false}
                          productData={productData}
                          handleVariantInputChange={handleVariantInputChange}
                        />
                      </div>
                    </td>
                    <td style={{ width: "150px", verticalAlign: "middle" }}>
                      {productData.productImageArray &&
                        productData.productImageArray?.length < 2 && (
                          <>
                            {uploading &&
                            loadingId === productData.productId ? (
                              <div
                                class="spinner-border text-danger"
                                style={{ marginTop: "10px" }}
                              ></div>
                            ) : (
                              <>
                                <div
                                  style={{
                                    border: "2px dotted black",
                                    cursor: "pointer",
                                    width: "70px",
                                  }}
                                >
                                  <label
                                    htmlFor={`variantImage${index}`}
                                    style={{
                                      cursor: "pointer",
                                      margin: "3px",
                                    }}
                                  >
                                    <AddPhotoAlternate />
                                    Add
                                  </label>
                                </div>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id={`variantImage${index}`}
                                  style={{
                                    display: "none",
                                  }}
                                  onChange={(e) => {
                                    variantImageUpload(e, productData);
                                  }}
                                  ref={ref}
                                  multiple
                                />
                              </>
                            )}
                          </>
                        )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "50%",
                        }}
                      >
                        {productData.productImageArray
                          ?.filter(Boolean)
                          .map((data) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  margin: "5px",
                                }}
                              >
                                <div
                                  style={{
                                    borderRadius: "10px",
                                  }}
                                >
                                  <img
                                    width={50}
                                    height={50}
                                    style={{ borderRadius: "10px" }}
                                    src={data}
                                    alt="Product Image"
                                  />
                                </div>
                                <div
                                  onClick={() =>
                                    removeVariantImage(data, productData)
                                  }
                                >
                                  <CancelIcon
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "-25px",
                                      color: "red",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productMrp}
                        placeholder="MRP"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productMrp"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productPrice}
                        placeholder="Selling Price"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="productPrice"
                      />
                    </td>
                    {shopDetails.advanceSettings?.b2bPricing && (
                      <td style={{ verticalAlign: "middle" }}>
                        <input
                          value={productData.b2bProductPrice}
                          placeholder="B2B Selling Price"
                          style={{ width: "100px" }}
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="b2bProductPrice"
                        />
                      </td>
                    )}
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.inventoryQty}
                        placeholder="Stock Count"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            parseFloat(e.target.value),
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="inventoryQty"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={
                          productData.purchasePrice
                            ? productData.purchasePrice
                            : productData.purchasePrice
                        }
                        placeholder="Purchase Price"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="purchasePrice"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productEANCode}
                        placeholder="EAN Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productEANCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productCode}
                        placeholder="Product Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productDescription}
                        placeholder="Product Description"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productDescription"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.discountPrice}
                        placeholder="Discount Amount"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        name="discountPrice"
                      />
                      <div>
                        <select
                          id="discountType"
                          name="discountType"
                          value={productData.discountType}
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                        >
                          <option value="">Type </option>
                          <option value="flat">Flat</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        value={productData.productHsnCode}
                        placeholder="HSN Code"
                        style={{ width: "100px" }}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                        name="productHsnCode"
                      />
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <div>
                        <select
                          id="taxId"
                          value={productData.taxId}
                          defaultValue="default"
                          name="taxId"
                          onChange={(e) =>
                            handleVariantInputChange(
                              e.target.name,
                              e.target.value,
                              productData.productId,
                            )
                          }
                        >
                          <option value="">Select tax </option>
                          {taxList.map((tax) => (
                            <option key={tax.taxId} value={tax.taxId}>
                              {tax.taxName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <select
                        id="taxIncExc"
                        defaultValue="default"
                        name="taxIncExc"
                        value={productData.taxIncExc}
                        onChange={(e) =>
                          handleVariantInputChange(
                            e.target.name,
                            e.target.value,
                            productData.productId,
                          )
                        }
                      >
                        <option value="">Select Inclusive/Exclusive </option>
                        <option value="inclusive">Inclusive</option>
                        <option value="exclusive">Exclusive</option>
                      </select>
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <DatePicker
                        type="date"
                        inputReadOnly={true}
                        style={{ width: "150px", borderRadius: "4px" }}
                        value={
                          productData.expiryDate !== "" &&
                          productData.expiryDate !== undefined
                            ? dayjs(productData.expiryDate)
                            : ""
                        }
                        disabledDate={disabledDate}
                        name="expiryDate"
                        onChange={(v) =>
                          handleVariantInputChange(
                            "expiryDate",
                            v,
                            productData.productId,
                          )
                        }
                      />
                    </td>
                    {shopDetails.shopType === "Jewellery Shop" && (
                      <>
                        <td style={{ verticalAlign: "middle" }}>
                          <input
                            value={productData.productWastage}
                            placeholder="Wastage"
                            style={{ width: "100px" }}
                            onChange={(e) =>
                              handleVariantInputChange(
                                e.target.name,
                                e.target.value,
                                productData.productId,
                              )
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            name="productWastage"
                          />
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <input
                            value={productData.productLabour}
                            placeholder="Labour Charge"
                            style={{ width: "100px" }}
                            onChange={(e) =>
                              handleVariantInputChange(
                                e.target.name,
                                e.target.value,
                                productData.productId,
                              )
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            name="productLabour"
                          />
                        </td>
                      </>
                    )}
                    <td style={{ verticalAlign: "middle" }}>
                      <Button
                        onClick={() =>
                          handleRemoveVariant(productData.productId)
                        }
                        size="sm"
                        variant="outline-danger"
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-warning"
            disabled={disabled}
            onClick={() => {
              setEditProductModal(false);
              setImageArrayUrl([]);
              setGroup([]);
              setCategory([]);
              setSubCategory([]);
              variantResetData();
              setEditProducts({
                ...INITIAL_STATE,
                productId: "",
                masterId: "",
                productImage: "",
                versionId: "",
                existingInventoryQty: "",
                status: "",
              });
              setNewQty(0);
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              if (rowSelection) {
                handleUpdateToVariant();
              } else if (isUpgradingToVariant) {
                handleUpdateToVariant();
              } else {
                updateProduct();
              }
            }}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={confirmModal}
        dialogClassName="custom-addproduct-modal"
        onHide={() => {
          setConfirmModal(false);
        }}
      >
        <Modal.Body>
          <CustomTable
            columns={tableColumns}
            style={{
              minHeight: "500px",
            }}
            rowKey={"productId"}
            data={rowSelectedProduct}
            pagination={false}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
export default withRouter(Items);
